import { format } from 'date-fns'

export const PAW_MOCK_DATA = {
  // sales
  earningHistory: [
    {
      id: '1',
      date: format(new Date(), 'yyyy-MM-dd'),
      activity: 'Sentri-7 Certification Completion',
      points: 1500,
    },
    {
      id: '2',
      date: format(
        new Date(Date.now() - 2 * 24 * 60 * 60 * 1000),
        'yyyy-MM-dd',
      ),
      activity: 'CRM Sync: Sentri-7 Contract - Acme Health',
      points: 3750,
    },
    {
      id: '3',
      date: format(
        new Date(Date.now() - 5 * 24 * 60 * 60 * 1000),
        'yyyy-MM-dd',
      ),
      activity: 'Recognition Award from Marcus Hayes',
      points: 1000,
    },
    {
      id: '4',
      date: format(
        new Date(Date.now() - 10 * 24 * 60 * 60 * 1000),
        'yyyy-MM-dd',
      ),
      activity: 'Sentri-7 Early Adopter Bonus',
      points: 2500,
    },
    {
      id: '5',
      date: '2026-01-20',
      activity: 'Monthly Sales Target Achieved',
      points: 3000,
    },
    {
      id: '6',
      date: '2026-01-15',
      activity: 'New Customer Acquisition Bonus',
      points: 1500,
    },
    {
      id: '7',
      date: '2026-01-10',
      activity: 'Product Training Completion',
      points: 500,
    },
    {
      id: '8',
      date: '2026-01-05',
      activity: 'Weekly Sales Target',
      points: 800,
    },
  ],
  redemptionHistory: [
    {
      id: '1',
      date: '2026-02-01',
      activity: 'Fitness Tracker',
      points: 12000,
      status: 'Completed' as const,
    },
    {
      id: '2',
      date: '2026-01-25',
      activity: 'Extra Vacation Day',
      points: 10000,
      status: 'Completed' as const,
    },
    {
      id: '3',
      date: '2026-01-18',
      activity: 'Wireless Headphones',
      points: 15000,
      status: 'Shipped' as const,
    },
    {
      id: '4',
      date: '2026-02-03',
      activity: 'Spa Treatment',
      points: 20000,
      status: 'Pending' as const,
    },
  ],
  // dealer staff
  storePerf: {
    locationId: 'loc-1',
    locationName: 'Calgary North Store',
    dealerId: 'dealer-1',
    monthlyRevenue: 21822,
    revenueChange: 6,
    pointsEarned: 36367,
    availablePoints: 34553,
    monthlyPointsEarned: 4781,
    unitsSold: 28,
    campaignParticipation: 67,
    tier: 'Silver',
  },
  storeLeaderboard: [
    {
      locationId: 'loc-7',
      locationName: 'Toronto East Store',
      dealerId: 'dealer-3',
      dealerName: 'Northern Drive Group',
      pointsEarned: 44721,
      revenue: 70321,
    },
    {
      locationId: 'loc-16',
      locationName: 'Denver Parts Store',
      dealerId: 'dealer-6',
      dealerName: 'Heartland Auto Supply',
      pointsEarned: 43326,
      revenue: 74776,
    },
    {
      locationId: 'loc-6',
      locationName: 'Burnaby Parts Location',
      dealerId: 'dealer-2',
      dealerName: 'Summit Parts Network',
      pointsEarned: 43155,
      revenue: 91977,
    },
    {
      locationId: 'loc-8',
      locationName: 'Mississauga Service Center',
      dealerId: 'dealer-3',
      dealerName: 'Northern Drive Group',
      pointsEarned: 42357,
      revenue: 88121,
    },
    {
      locationId: 'loc-24',
      locationName: 'Fort Worth Retail Location',
      dealerId: 'dealer-9',
      dealerName: 'Frontier Brake Specialists',
      pointsEarned: 41104,
      revenue: 67976,
    },
    {
      locationId: 'loc-11',
      locationName: 'Kingston Parts Location',
      dealerId: 'dealer-4',
      dealerName: 'Velocity Service Network',
      pointsEarned: 40680,
      revenue: 36212,
    },
    {
      locationId: 'loc-2',
      locationName: 'Edmonton West Location',
      dealerId: 'dealer-1',
      dealerName: 'Apex Auto Group',
      pointsEarned: 40664,
      revenue: 92885,
    },
    {
      locationId: 'loc-20',
      locationName: 'Salem Retail Store',
      dealerId: 'dealer-7',
      dealerName: 'Atlantic Service Centers',
      pointsEarned: 36938,
      revenue: 55362,
    },
    {
      locationId: 'loc-1',
      locationName: 'Calgary North Store',
      dealerId: 'dealer-1',
      dealerName: 'Apex Auto Group',
      pointsEarned: 36367,
      revenue: 21822,
    },
    {
      locationId: 'loc-27',
      locationName: 'Chicago West Store',
      dealerId: 'dealer-11',
      dealerName: 'Mountain View Service',
      pointsEarned: 34906,
      revenue: 89686,
    },
    {
      locationId: 'loc-21',
      locationName: 'Phoenix North Store',
      dealerId: 'dealer-8',
      dealerName: 'Pinnacle Parts Plus',
      pointsEarned: 34758,
      revenue: 75971,
    },
    {
      locationId: 'loc-18',
      locationName: 'Store 3',
      dealerId: 'dealer-6',
      dealerName: 'Heartland Auto Supply',
      pointsEarned: 34619,
      revenue: 31744,
    },
    {
      locationId: 'loc-26',
      locationName: 'Oceanside Parts Store',
      dealerId: 'dealer-10',
      dealerName: 'Coastal Auto Partners',
      pointsEarned: 32595,
      revenue: 88725,
    },
    {
      locationId: 'loc-28',
      locationName: 'Milwaukee Retail Location',
      dealerId: 'dealer-11',
      dealerName: 'Mountain View Service',
      pointsEarned: 32173,
      revenue: 44520,
    },
    {
      locationId: 'loc-22',
      locationName: 'Tucson Parts Location',
      dealerId: 'dealer-8',
      dealerName: 'Pinnacle Parts Plus',
      pointsEarned: 30035,
      revenue: 70543,
    },
    {
      locationId: 'loc-5',
      locationName: 'Surrey Service Center',
      dealerId: 'dealer-2',
      dealerName: 'Summit Parts Network',
      pointsEarned: 29893,
      revenue: 92959,
    },
    {
      locationId: 'loc-3',
      locationName: 'Red Deer Service Center',
      dealerId: 'dealer-1',
      dealerName: 'Apex Auto Group',
      pointsEarned: 29709,
      revenue: 87107,
    },
    {
      locationId: 'loc-10',
      locationName: 'Ottawa Central Store',
      dealerId: 'dealer-4',
      dealerName: 'Velocity Service Network',
      pointsEarned: 27564,
      revenue: 61057,
    },
    {
      locationId: 'loc-30',
      locationName: 'Grand Rapids Service Center',
      dealerId: 'dealer-12',
      dealerName: 'Great Lakes Parts Supply',
      pointsEarned: 24764,
      revenue: 93870,
    },
    {
      locationId: 'loc-13',
      locationName: 'Winnipeg Main Store',
      dealerId: 'dealer-5',
      dealerName: 'Pacific Brake Partners',
      pointsEarned: 24052,
      revenue: 29202,
    },
    {
      locationId: 'loc-19',
      locationName: 'Portland Service Center',
      dealerId: 'dealer-7',
      dealerName: 'Atlantic Service Centers',
      pointsEarned: 22326,
      revenue: 41607,
    },
    {
      locationId: 'loc-9',
      locationName: 'Hamilton Retail Location',
      dealerId: 'dealer-3',
      dealerName: 'Northern Drive Group',
      pointsEarned: 22007,
      revenue: 89105,
    },
    {
      locationId: 'loc-12',
      locationName: 'Barrie Service Center',
      dealerId: 'dealer-4',
      dealerName: 'Velocity Service Network',
      pointsEarned: 20601,
      revenue: 91581,
    },
    {
      locationId: 'loc-25',
      locationName: 'San Diego Service Center',
      dealerId: 'dealer-10',
      dealerName: 'Coastal Auto Partners',
      pointsEarned: 17352,
      revenue: 61412,
    },
    {
      locationId: 'loc-4',
      locationName: 'Vancouver Central Store',
      dealerId: 'dealer-2',
      dealerName: 'Summit Parts Network',
      pointsEarned: 15609,
      revenue: 56201,
    },
    {
      locationId: 'loc-15',
      locationName: 'Saskatoon Service Center',
      dealerId: 'dealer-5',
      dealerName: 'Pacific Brake Partners',
      pointsEarned: 15314,
      revenue: 25537,
    },
    {
      locationId: 'loc-17',
      locationName: 'Colorado Springs Location',
      dealerId: 'dealer-6',
      dealerName: 'Heartland Auto Supply',
      pointsEarned: 15269,
      revenue: 67335,
    },
    {
      locationId: 'loc-23',
      locationName: 'Dallas Central Store',
      dealerId: 'dealer-9',
      dealerName: 'Frontier Brake Specialists',
      pointsEarned: 15196,
      revenue: 49882,
    },
    {
      locationId: 'loc-29',
      locationName: 'Detroit North Store',
      dealerId: 'dealer-12',
      dealerName: 'Great Lakes Parts Supply',
      pointsEarned: 12520,
      revenue: 53065,
    },
    {
      locationId: 'loc-14',
      locationName: 'Regina Retail Location',
      dealerId: 'dealer-5',
      dealerName: 'Pacific Brake Partners',
      pointsEarned: 5142,
      revenue: 16328,
    },
  ],
  // program admin
  periodMetrics: {
    totalPoints: 309360000,
    totalPointsFormatted: '309.4M',
    avgPoints: 308743,
    avgPointsFormatted: '308,743',
    revenue: 4463400000,
    revenueFormatted: '$4463M',
    salesCount: 39078,
    salesCountFormatted: '39,078',
    activePromotions: 8,
    totalMembers: 1002,
    pointsChange: 13.636363636363635,
    avgChange: 13.636714968733092,
    revenueChange: 11.11111111111111,
    salesChange: 9.890048086386773,
    label: 'YTD',
    trendLabel: 'vs last year',
  },
  totalRegions: 6,
  totalTeams: 48,
  ytdTotals: {
    points: 309360000,
    revenue: 4463400000,
    salesCount: 39078,
  },
  organizationalGoals: {
    annual: {
      revenue: 5356080000,
      salesCount: 50100,
      points: 355764000,
    },
    quarterly: {
      q4: {
        revenue: 1472922000,
        salesCount: 14028,
        points: 97448400,
      },
    },
  },
  q4Totals: {
    points: 30936000,
    revenue: 446340000,
    salesCount: 3808,
  },
  regionPerformance: [
    {
      name: 'International',
      points: 8426,
      target: 1600,
      revenue: 122,
      attainment: 527,
    },
    {
      name: 'West',
      points: 7108,
      target: 1600,
      revenue: 103,
      attainment: 444,
    },
    {
      name: 'Southwest',
      points: 5790,
      target: 1600,
      revenue: 84,
      attainment: 362,
    },
    {
      name: 'Central',
      points: 4522,
      target: 1600,
      revenue: 65,
      attainment: 283,
    },
    {
      name: 'Southeast',
      points: 3204,
      target: 1600,
      revenue: 46,
      attainment: 200,
    },
    {
      name: 'Northeast',
      points: 1886,
      target: 1600,
      revenue: 26,
      attainment: 118,
    },
  ],
  orgData: {
    regions: [
      {
        id: 'region-6',
        name: 'International',
        managerId: 'rm-6',
        teams: [
          {
            id: 'team-41',
            name: 'International Alpha',
            regionId: 'region-6',
            manager: 'Barbara Jenkins',
            managerId: 'manager-41',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 980000,
            monthlyTarget: 200000,
            totalRevenue: 14200000,
            revenueTarget: 3000000,
            dealsCompleted: 80,
            avgPointsPerMember: 49000,
            campaignParticipation: 75,
            trainingCompletion: 85,
            pendingApprovals: 0,
            status: 'exceeding',
          },
          {
            id: 'team-42',
            name: 'International Beta',
            regionId: 'region-6',
            manager: 'Nathan Ward',
            managerId: 'manager-42',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 1017000,
            monthlyTarget: 200000,
            totalRevenue: 14730000,
            revenueTarget: 3000000,
            dealsCompleted: 87,
            avgPointsPerMember: 48428,
            campaignParticipation: 78,
            trainingCompletion: 90,
            pendingApprovals: 2,
            status: 'exceeding',
          },
          {
            id: 'team-43',
            name: 'International Gamma',
            regionId: 'region-6',
            manager: 'Nicholas Richardson',
            managerId: 'manager-43',
            memberCount: 22,
            activeSalespeople: 22,
            totalPoints: 1004000,
            monthlyTarget: 200000,
            totalRevenue: 14760000,
            revenueTarget: 3000000,
            dealsCompleted: 94,
            avgPointsPerMember: 45636,
            campaignParticipation: 81,
            trainingCompletion: 60,
            pendingApprovals: 4,
            status: 'exceeding',
          },
          {
            id: 'team-44',
            name: 'International Delta',
            regionId: 'region-6',
            manager: 'Jacob Lewis',
            managerId: 'manager-44',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 1041000,
            monthlyTarget: 200000,
            totalRevenue: 15290000,
            revenueTarget: 3000000,
            dealsCompleted: 101,
            avgPointsPerMember: 52050,
            campaignParticipation: 84,
            trainingCompletion: 65,
            pendingApprovals: 1,
            status: 'exceeding',
          },
          {
            id: 'team-45',
            name: 'International Epsilon',
            regionId: 'region-6',
            manager: 'Daniel Thompson',
            managerId: 'manager-45',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 1078000,
            monthlyTarget: 200000,
            totalRevenue: 15320000,
            revenueTarget: 3000000,
            dealsCompleted: 108,
            avgPointsPerMember: 51333,
            campaignParticipation: 87,
            trainingCompletion: 70,
            pendingApprovals: 3,
            status: 'exceeding',
          },
          {
            id: 'team-46',
            name: 'International Zeta',
            regionId: 'region-6',
            manager: 'Jessica Hill',
            managerId: 'manager-46',
            memberCount: 22,
            activeSalespeople: 22,
            totalPoints: 1065000,
            monthlyTarget: 200000,
            totalRevenue: 15850000,
            revenueTarget: 3000000,
            dealsCompleted: 115,
            avgPointsPerMember: 48409,
            campaignParticipation: 90,
            trainingCompletion: 75,
            pendingApprovals: 0,
            status: 'exceeding',
          },
          {
            id: 'team-47',
            name: 'International Eta',
            regionId: 'region-6',
            manager: 'Benjamin Cox',
            managerId: 'manager-47',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 1102000,
            monthlyTarget: 200000,
            totalRevenue: 15880000,
            revenueTarget: 3000000,
            dealsCompleted: 82,
            avgPointsPerMember: 55100,
            campaignParticipation: 93,
            trainingCompletion: 80,
            pendingApprovals: 2,
            status: 'exceeding',
          },
          {
            id: 'team-48',
            name: 'International Theta',
            regionId: 'region-6',
            manager: 'Alexander Morgan',
            managerId: 'manager-48',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 1139000,
            monthlyTarget: 200000,
            totalRevenue: 16410000,
            revenueTarget: 3000000,
            dealsCompleted: 89,
            avgPointsPerMember: 54238,
            campaignParticipation: 76,
            trainingCompletion: 85,
            pendingApprovals: 4,
            status: 'exceeding',
          },
        ],
        totalMembers: 167,
        totalPoints: 8426000,
        totalRevenue: 122440000,
        regionalTarget: 1600000,
        revenueTarget: 24000000,
        attainmentPercent: 527,
        revenueAttainment: 510,
        avgCampaignParticipation: 83,
        totalPendingApprovals: 16,
        teamsExceeding: 8,
        teamsNeedingAttention: 0,
      },
      {
        id: 'region-5',
        name: 'West',
        managerId: 'rm-5',
        teams: [
          {
            id: 'team-33',
            name: 'West Alpha',
            regionId: 'region-5',
            manager: 'Barbara Myers',
            managerId: 'manager-33',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 834000,
            monthlyTarget: 200000,
            totalRevenue: 11960000,
            revenueTarget: 3000000,
            dealsCompleted: 104,
            avgPointsPerMember: 41700,
            campaignParticipation: 91,
            trainingCompletion: 80,
            pendingApprovals: 4,
            status: 'exceeding',
          },
          {
            id: 'team-34',
            name: 'West Beta',
            regionId: 'region-5',
            manager: 'Olivia Garcia',
            managerId: 'manager-34',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 821000,
            monthlyTarget: 200000,
            totalRevenue: 11990000,
            revenueTarget: 3000000,
            dealsCompleted: 111,
            avgPointsPerMember: 39095,
            campaignParticipation: 94,
            trainingCompletion: 85,
            pendingApprovals: 1,
            status: 'exceeding',
          },
          {
            id: 'team-35',
            name: 'West Gamma',
            regionId: 'region-5',
            manager: 'Christina Ward',
            managerId: 'manager-35',
            memberCount: 22,
            activeSalespeople: 22,
            totalPoints: 858000,
            monthlyTarget: 200000,
            totalRevenue: 12520000,
            revenueTarget: 3000000,
            dealsCompleted: 118,
            avgPointsPerMember: 39000,
            campaignParticipation: 77,
            trainingCompletion: 90,
            pendingApprovals: 3,
            status: 'exceeding',
          },
          {
            id: 'team-36',
            name: 'West Delta',
            regionId: 'region-5',
            manager: 'Jerry Carter',
            managerId: 'manager-36',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 895000,
            monthlyTarget: 200000,
            totalRevenue: 12550000,
            revenueTarget: 3000000,
            dealsCompleted: 85,
            avgPointsPerMember: 44750,
            campaignParticipation: 80,
            trainingCompletion: 60,
            pendingApprovals: 0,
            status: 'exceeding',
          },
          {
            id: 'team-37',
            name: 'West Epsilon',
            regionId: 'region-5',
            manager: 'Heather Collins',
            managerId: 'manager-37',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 882000,
            monthlyTarget: 200000,
            totalRevenue: 13080000,
            revenueTarget: 3000000,
            dealsCompleted: 92,
            avgPointsPerMember: 42000,
            campaignParticipation: 83,
            trainingCompletion: 65,
            pendingApprovals: 2,
            status: 'exceeding',
          },
          {
            id: 'team-38',
            name: 'West Zeta',
            regionId: 'region-5',
            manager: 'Brenda Clark',
            managerId: 'manager-38',
            memberCount: 22,
            activeSalespeople: 22,
            totalPoints: 919000,
            monthlyTarget: 200000,
            totalRevenue: 13110000,
            revenueTarget: 3000000,
            dealsCompleted: 99,
            avgPointsPerMember: 41772,
            campaignParticipation: 86,
            trainingCompletion: 70,
            pendingApprovals: 4,
            status: 'exceeding',
          },
          {
            id: 'team-39',
            name: 'West Eta',
            regionId: 'region-5',
            manager: 'Helen Robinson',
            managerId: 'manager-39',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 956000,
            monthlyTarget: 200000,
            totalRevenue: 13640000,
            revenueTarget: 3000000,
            dealsCompleted: 106,
            avgPointsPerMember: 47800,
            campaignParticipation: 89,
            trainingCompletion: 75,
            pendingApprovals: 1,
            status: 'exceeding',
          },
          {
            id: 'team-40',
            name: 'West Theta',
            regionId: 'region-5',
            manager: 'Laura Kim',
            managerId: 'manager-40',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 943000,
            monthlyTarget: 200000,
            totalRevenue: 14170000,
            revenueTarget: 3000000,
            dealsCompleted: 113,
            avgPointsPerMember: 44904,
            campaignParticipation: 92,
            trainingCompletion: 80,
            pendingApprovals: 3,
            status: 'exceeding',
          },
        ],
        totalMembers: 167,
        totalPoints: 7108000,
        totalRevenue: 103020000,
        regionalTarget: 1600000,
        revenueTarget: 24000000,
        attainmentPercent: 444,
        revenueAttainment: 429,
        avgCampaignParticipation: 87,
        totalPendingApprovals: 18,
        teamsExceeding: 8,
        teamsNeedingAttention: 0,
      },
      {
        id: 'region-4',
        name: 'Southwest',
        managerId: 'rm-4',
        teams: [
          {
            id: 'team-25',
            name: 'Southwest Alpha',
            regionId: 'region-4',
            manager: 'Jacob Williams',
            managerId: 'manager-25',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 638000,
            monthlyTarget: 200000,
            totalRevenue: 9220000,
            revenueTarget: 3000000,
            dealsCompleted: 88,
            avgPointsPerMember: 31900,
            campaignParticipation: 87,
            trainingCompletion: 75,
            pendingApprovals: 3,
            status: 'exceeding',
          },
          {
            id: 'team-26',
            name: 'Southwest Beta',
            regionId: 'region-4',
            manager: 'Aaron Perry',
            managerId: 'manager-26',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 675000,
            monthlyTarget: 200000,
            totalRevenue: 9750000,
            revenueTarget: 3000000,
            dealsCompleted: 95,
            avgPointsPerMember: 32142,
            campaignParticipation: 90,
            trainingCompletion: 80,
            pendingApprovals: 0,
            status: 'exceeding',
          },
          {
            id: 'team-27',
            name: 'Southwest Gamma',
            regionId: 'region-4',
            manager: 'Amanda Harris',
            managerId: 'manager-27',
            memberCount: 22,
            activeSalespeople: 22,
            totalPoints: 712000,
            monthlyTarget: 200000,
            totalRevenue: 10280000,
            revenueTarget: 3000000,
            dealsCompleted: 102,
            avgPointsPerMember: 32363,
            campaignParticipation: 93,
            trainingCompletion: 85,
            pendingApprovals: 2,
            status: 'exceeding',
          },
          {
            id: 'team-28',
            name: 'Southwest Delta',
            regionId: 'region-4',
            manager: 'Sharon Myers',
            managerId: 'manager-28',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 699000,
            monthlyTarget: 200000,
            totalRevenue: 10310000,
            revenueTarget: 3000000,
            dealsCompleted: 109,
            avgPointsPerMember: 34950,
            campaignParticipation: 76,
            trainingCompletion: 90,
            pendingApprovals: 4,
            status: 'exceeding',
          },
          {
            id: 'team-29',
            name: 'Southwest Epsilon',
            regionId: 'region-4',
            manager: 'James Lopez',
            managerId: 'manager-29',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 736000,
            monthlyTarget: 200000,
            totalRevenue: 10840000,
            revenueTarget: 3000000,
            dealsCompleted: 116,
            avgPointsPerMember: 35047,
            campaignParticipation: 79,
            trainingCompletion: 60,
            pendingApprovals: 1,
            status: 'exceeding',
          },
          {
            id: 'team-30',
            name: 'Southwest Zeta',
            regionId: 'region-4',
            manager: 'Brandon Martinez',
            managerId: 'manager-30',
            memberCount: 22,
            activeSalespeople: 22,
            totalPoints: 773000,
            monthlyTarget: 200000,
            totalRevenue: 10870000,
            revenueTarget: 3000000,
            dealsCompleted: 83,
            avgPointsPerMember: 35136,
            campaignParticipation: 82,
            trainingCompletion: 65,
            pendingApprovals: 3,
            status: 'exceeding',
          },
          {
            id: 'team-31',
            name: 'Southwest Eta',
            regionId: 'region-4',
            manager: 'Robert Baker',
            managerId: 'manager-31',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 760000,
            monthlyTarget: 200000,
            totalRevenue: 11400000,
            revenueTarget: 3000000,
            dealsCompleted: 90,
            avgPointsPerMember: 38000,
            campaignParticipation: 85,
            trainingCompletion: 70,
            pendingApprovals: 0,
            status: 'exceeding',
          },
          {
            id: 'team-32',
            name: 'Southwest Theta',
            regionId: 'region-4',
            manager: 'William Baker',
            managerId: 'manager-32',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 797000,
            monthlyTarget: 200000,
            totalRevenue: 11430000,
            revenueTarget: 3000000,
            dealsCompleted: 97,
            avgPointsPerMember: 37952,
            campaignParticipation: 88,
            trainingCompletion: 75,
            pendingApprovals: 2,
            status: 'exceeding',
          },
        ],
        totalMembers: 167,
        totalPoints: 5790000,
        totalRevenue: 84100000,
        regionalTarget: 1600000,
        revenueTarget: 24000000,
        attainmentPercent: 362,
        revenueAttainment: 350,
        avgCampaignParticipation: 85,
        totalPendingApprovals: 15,
        teamsExceeding: 8,
        teamsNeedingAttention: 0,
      },
      {
        id: 'region-3',
        name: 'Central',
        managerId: 'rm-3',
        teams: [
          {
            id: 'team-17',
            name: 'Central Alpha',
            regionId: 'region-3',
            manager: 'Richard Adams',
            managerId: 'manager-17',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 492000,
            monthlyTarget: 200000,
            totalRevenue: 6980000,
            revenueTarget: 3000000,
            dealsCompleted: 112,
            avgPointsPerMember: 24600,
            campaignParticipation: 83,
            trainingCompletion: 70,
            pendingApprovals: 2,
            status: 'exceeding',
          },
          {
            id: 'team-18',
            name: 'Central Beta',
            regionId: 'region-3',
            manager: 'Christina Ortiz',
            managerId: 'manager-18',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 529000,
            monthlyTarget: 200000,
            totalRevenue: 7510000,
            revenueTarget: 3000000,
            dealsCompleted: 119,
            avgPointsPerMember: 25190,
            campaignParticipation: 86,
            trainingCompletion: 75,
            pendingApprovals: 4,
            status: 'exceeding',
          },
          {
            id: 'team-19',
            name: 'Central Gamma',
            regionId: 'region-3',
            manager: 'Christopher Alvarez',
            managerId: 'manager-19',
            memberCount: 22,
            activeSalespeople: 22,
            totalPoints: 516000,
            monthlyTarget: 200000,
            totalRevenue: 7540000,
            revenueTarget: 3000000,
            dealsCompleted: 86,
            avgPointsPerMember: 23454,
            campaignParticipation: 89,
            trainingCompletion: 80,
            pendingApprovals: 1,
            status: 'exceeding',
          },
          {
            id: 'team-20',
            name: 'Central Delta',
            regionId: 'region-3',
            manager: 'Kathleen Evans',
            managerId: 'manager-20',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 553000,
            monthlyTarget: 200000,
            totalRevenue: 8070000,
            revenueTarget: 3000000,
            dealsCompleted: 93,
            avgPointsPerMember: 27650,
            campaignParticipation: 92,
            trainingCompletion: 85,
            pendingApprovals: 3,
            status: 'exceeding',
          },
          {
            id: 'team-21',
            name: 'Central Epsilon',
            regionId: 'region-3',
            manager: 'Laura Ward',
            managerId: 'manager-21',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 590000,
            monthlyTarget: 200000,
            totalRevenue: 8100000,
            revenueTarget: 3000000,
            dealsCompleted: 100,
            avgPointsPerMember: 28095,
            campaignParticipation: 75,
            trainingCompletion: 90,
            pendingApprovals: 0,
            status: 'exceeding',
          },
          {
            id: 'team-22',
            name: 'Central Zeta',
            regionId: 'region-3',
            manager: 'Gary Anderson',
            managerId: 'manager-22',
            memberCount: 22,
            activeSalespeople: 22,
            totalPoints: 577000,
            monthlyTarget: 200000,
            totalRevenue: 8630000,
            revenueTarget: 3000000,
            dealsCompleted: 107,
            avgPointsPerMember: 26227,
            campaignParticipation: 78,
            trainingCompletion: 60,
            pendingApprovals: 2,
            status: 'exceeding',
          },
          {
            id: 'team-23',
            name: 'Central Eta',
            regionId: 'region-3',
            manager: 'Carol Roberts',
            managerId: 'manager-23',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 614000,
            monthlyTarget: 200000,
            totalRevenue: 8660000,
            revenueTarget: 3000000,
            dealsCompleted: 114,
            avgPointsPerMember: 30700,
            campaignParticipation: 81,
            trainingCompletion: 65,
            pendingApprovals: 4,
            status: 'exceeding',
          },
          {
            id: 'team-24',
            name: 'Central Theta',
            regionId: 'region-3',
            manager: 'Shirley Rodriguez',
            managerId: 'manager-24',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 651000,
            monthlyTarget: 200000,
            totalRevenue: 9190000,
            revenueTarget: 3000000,
            dealsCompleted: 81,
            avgPointsPerMember: 31000,
            campaignParticipation: 84,
            trainingCompletion: 70,
            pendingApprovals: 1,
            status: 'exceeding',
          },
        ],
        totalMembers: 167,
        totalPoints: 4522000,
        totalRevenue: 64680000,
        regionalTarget: 1600000,
        revenueTarget: 24000000,
        attainmentPercent: 283,
        revenueAttainment: 270,
        avgCampaignParticipation: 84,
        totalPendingApprovals: 17,
        teamsExceeding: 8,
        teamsNeedingAttention: 0,
      },
      {
        id: 'region-2',
        name: 'Southeast',
        managerId: 'rm-2',
        teams: [
          {
            id: 'team-9',
            name: 'Southeast Alpha',
            regionId: 'region-2',
            manager: 'Daniel White',
            managerId: 'manager-9',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 346000,
            monthlyTarget: 200000,
            totalRevenue: 4740000,
            revenueTarget: 3000000,
            dealsCompleted: 96,
            avgPointsPerMember: 17300,
            campaignParticipation: 79,
            trainingCompletion: 65,
            pendingApprovals: 1,
            status: 'exceeding',
          },
          {
            id: 'team-10',
            name: 'Southeast Beta',
            regionId: 'region-2',
            manager: 'Jessica Richardson',
            managerId: 'manager-10',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 333000,
            monthlyTarget: 200000,
            totalRevenue: 4770000,
            revenueTarget: 3000000,
            dealsCompleted: 103,
            avgPointsPerMember: 15857,
            campaignParticipation: 82,
            trainingCompletion: 70,
            pendingApprovals: 3,
            status: 'exceeding',
          },
          {
            id: 'team-11',
            name: 'Southeast Gamma',
            regionId: 'region-2',
            manager: 'Karen Morgan',
            managerId: 'manager-11',
            memberCount: 22,
            activeSalespeople: 22,
            totalPoints: 370000,
            monthlyTarget: 200000,
            totalRevenue: 5300000,
            revenueTarget: 3000000,
            dealsCompleted: 110,
            avgPointsPerMember: 16818,
            campaignParticipation: 85,
            trainingCompletion: 75,
            pendingApprovals: 0,
            status: 'exceeding',
          },
          {
            id: 'team-12',
            name: 'Southeast Delta',
            regionId: 'region-2',
            manager: 'Patricia Nguyen',
            managerId: 'manager-12',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 407000,
            monthlyTarget: 200000,
            totalRevenue: 5330000,
            revenueTarget: 3000000,
            dealsCompleted: 117,
            avgPointsPerMember: 20350,
            campaignParticipation: 88,
            trainingCompletion: 80,
            pendingApprovals: 2,
            status: 'exceeding',
          },
          {
            id: 'team-13',
            name: 'Southeast Epsilon',
            regionId: 'region-2',
            manager: 'Eric Edwards',
            managerId: 'manager-13',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 394000,
            monthlyTarget: 200000,
            totalRevenue: 5860000,
            revenueTarget: 3000000,
            dealsCompleted: 84,
            avgPointsPerMember: 18761,
            campaignParticipation: 91,
            trainingCompletion: 85,
            pendingApprovals: 4,
            status: 'exceeding',
          },
          {
            id: 'team-14',
            name: 'Southeast Zeta',
            regionId: 'region-2',
            manager: 'Ruth Morris',
            managerId: 'manager-14',
            memberCount: 22,
            activeSalespeople: 22,
            totalPoints: 431000,
            monthlyTarget: 200000,
            totalRevenue: 6390000,
            revenueTarget: 3000000,
            dealsCompleted: 91,
            avgPointsPerMember: 19590,
            campaignParticipation: 94,
            trainingCompletion: 90,
            pendingApprovals: 1,
            status: 'exceeding',
          },
          {
            id: 'team-15',
            name: 'Southeast Eta',
            regionId: 'region-2',
            manager: 'Samuel Lewis',
            managerId: 'manager-15',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 468000,
            monthlyTarget: 200000,
            totalRevenue: 6420000,
            revenueTarget: 3000000,
            dealsCompleted: 98,
            avgPointsPerMember: 23400,
            campaignParticipation: 77,
            trainingCompletion: 60,
            pendingApprovals: 3,
            status: 'exceeding',
          },
          {
            id: 'team-16',
            name: 'Southeast Theta',
            regionId: 'region-2',
            manager: 'Carol Howard',
            managerId: 'manager-16',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 455000,
            monthlyTarget: 200000,
            totalRevenue: 6950000,
            revenueTarget: 3000000,
            dealsCompleted: 105,
            avgPointsPerMember: 21666,
            campaignParticipation: 80,
            trainingCompletion: 65,
            pendingApprovals: 0,
            status: 'exceeding',
          },
        ],
        totalMembers: 167,
        totalPoints: 3204000,
        totalRevenue: 45760000,
        regionalTarget: 1600000,
        revenueTarget: 24000000,
        attainmentPercent: 200,
        revenueAttainment: 191,
        avgCampaignParticipation: 85,
        totalPendingApprovals: 14,
        teamsExceeding: 8,
        teamsNeedingAttention: 0,
      },
      {
        id: 'region-1',
        name: 'Northeast',
        managerId: 'rm-1',
        teams: [
          {
            id: 'team-1',
            name: 'Northeast Alpha',
            regionId: 'region-1',
            manager: 'Marcus Hayes',
            managerId: 'manager-1',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 150000,
            monthlyTarget: 200000,
            totalRevenue: 2000000,
            revenueTarget: 3000000,
            dealsCompleted: 80,
            avgPointsPerMember: 7500,
            campaignParticipation: 75,
            trainingCompletion: 60,
            pendingApprovals: 0,
            status: 'needs_attention',
          },
          {
            id: 'team-2',
            name: 'Northeast Beta',
            regionId: 'region-1',
            manager: 'Virginia White',
            managerId: 'manager-2',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 187000,
            monthlyTarget: 200000,
            totalRevenue: 2530000,
            revenueTarget: 3000000,
            dealsCompleted: 87,
            avgPointsPerMember: 8904,
            campaignParticipation: 78,
            trainingCompletion: 65,
            pendingApprovals: 2,
            status: 'on_track',
          },
          {
            id: 'team-3',
            name: 'Northeast Gamma',
            regionId: 'region-1',
            manager: 'Dorothy Diaz',
            managerId: 'manager-3',
            memberCount: 22,
            activeSalespeople: 22,
            totalPoints: 224000,
            monthlyTarget: 200000,
            totalRevenue: 3060000,
            revenueTarget: 3000000,
            dealsCompleted: 94,
            avgPointsPerMember: 10181,
            campaignParticipation: 81,
            trainingCompletion: 70,
            pendingApprovals: 4,
            status: 'exceeding',
          },
          {
            id: 'team-4',
            name: 'Northeast Delta',
            regionId: 'region-1',
            manager: 'Raymond Morgan',
            managerId: 'manager-4',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 211000,
            monthlyTarget: 200000,
            totalRevenue: 3090000,
            revenueTarget: 3000000,
            dealsCompleted: 101,
            avgPointsPerMember: 10550,
            campaignParticipation: 84,
            trainingCompletion: 75,
            pendingApprovals: 1,
            status: 'exceeding',
          },
          {
            id: 'team-5',
            name: 'Northeast Epsilon',
            regionId: 'region-1',
            manager: 'Christopher Martin',
            managerId: 'manager-5',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 248000,
            monthlyTarget: 200000,
            totalRevenue: 3620000,
            revenueTarget: 3000000,
            dealsCompleted: 108,
            avgPointsPerMember: 11809,
            campaignParticipation: 87,
            trainingCompletion: 80,
            pendingApprovals: 3,
            status: 'exceeding',
          },
          {
            id: 'team-6',
            name: 'Northeast Zeta',
            regionId: 'region-1',
            manager: 'Patricia Russell',
            managerId: 'manager-6',
            memberCount: 22,
            activeSalespeople: 22,
            totalPoints: 285000,
            monthlyTarget: 200000,
            totalRevenue: 3650000,
            revenueTarget: 3000000,
            dealsCompleted: 115,
            avgPointsPerMember: 12954,
            campaignParticipation: 90,
            trainingCompletion: 85,
            pendingApprovals: 0,
            status: 'exceeding',
          },
          {
            id: 'team-7',
            name: 'Northeast Eta',
            regionId: 'region-1',
            manager: 'Deborah Wilson',
            managerId: 'manager-7',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 272000,
            monthlyTarget: 200000,
            totalRevenue: 4180000,
            revenueTarget: 3000000,
            dealsCompleted: 82,
            avgPointsPerMember: 13600,
            campaignParticipation: 93,
            trainingCompletion: 90,
            pendingApprovals: 2,
            status: 'exceeding',
          },
          {
            id: 'team-8',
            name: 'Northeast Theta',
            regionId: 'region-1',
            manager: 'George Morales',
            managerId: 'manager-8',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 309000,
            monthlyTarget: 200000,
            totalRevenue: 4210000,
            revenueTarget: 3000000,
            dealsCompleted: 89,
            avgPointsPerMember: 14714,
            campaignParticipation: 76,
            trainingCompletion: 60,
            pendingApprovals: 4,
            status: 'exceeding',
          },
        ],
        totalMembers: 167,
        totalPoints: 1886000,
        totalRevenue: 26340000,
        regionalTarget: 1600000,
        revenueTarget: 24000000,
        attainmentPercent: 118,
        revenueAttainment: 110,
        avgCampaignParticipation: 83,
        totalPendingApprovals: 16,
        teamsExceeding: 6,
        teamsNeedingAttention: 1,
      },
    ],
    allTeams: [
      {
        id: 'team-1',
        name: 'Northeast Alpha',
        regionId: 'region-1',
        manager: 'Marcus Hayes',
        managerId: 'manager-1',
        memberCount: 20,
        activeSalespeople: 20,
        totalPoints: 150000,
        monthlyTarget: 200000,
        totalRevenue: 2000000,
        revenueTarget: 3000000,
        dealsCompleted: 80,
        avgPointsPerMember: 7500,
        campaignParticipation: 75,
        trainingCompletion: 60,
        pendingApprovals: 0,
        status: 'needs_attention',
      },
      {
        id: 'team-2',
        name: 'Northeast Beta',
        regionId: 'region-1',
        manager: 'Virginia White',
        managerId: 'manager-2',
        memberCount: 21,
        activeSalespeople: 21,
        totalPoints: 187000,
        monthlyTarget: 200000,
        totalRevenue: 2530000,
        revenueTarget: 3000000,
        dealsCompleted: 87,
        avgPointsPerMember: 8904,
        campaignParticipation: 78,
        trainingCompletion: 65,
        pendingApprovals: 2,
        status: 'on_track',
      },
      {
        id: 'team-3',
        name: 'Northeast Gamma',
        regionId: 'region-1',
        manager: 'Dorothy Diaz',
        managerId: 'manager-3',
        memberCount: 22,
        activeSalespeople: 22,
        totalPoints: 224000,
        monthlyTarget: 200000,
        totalRevenue: 3060000,
        revenueTarget: 3000000,
        dealsCompleted: 94,
        avgPointsPerMember: 10181,
        campaignParticipation: 81,
        trainingCompletion: 70,
        pendingApprovals: 4,
        status: 'exceeding',
      },
      {
        id: 'team-4',
        name: 'Northeast Delta',
        regionId: 'region-1',
        manager: 'Raymond Morgan',
        managerId: 'manager-4',
        memberCount: 20,
        activeSalespeople: 20,
        totalPoints: 211000,
        monthlyTarget: 200000,
        totalRevenue: 3090000,
        revenueTarget: 3000000,
        dealsCompleted: 101,
        avgPointsPerMember: 10550,
        campaignParticipation: 84,
        trainingCompletion: 75,
        pendingApprovals: 1,
        status: 'exceeding',
      },
      {
        id: 'team-5',
        name: 'Northeast Epsilon',
        regionId: 'region-1',
        manager: 'Christopher Martin',
        managerId: 'manager-5',
        memberCount: 21,
        activeSalespeople: 21,
        totalPoints: 248000,
        monthlyTarget: 200000,
        totalRevenue: 3620000,
        revenueTarget: 3000000,
        dealsCompleted: 108,
        avgPointsPerMember: 11809,
        campaignParticipation: 87,
        trainingCompletion: 80,
        pendingApprovals: 3,
        status: 'exceeding',
      },
      {
        id: 'team-6',
        name: 'Northeast Zeta',
        regionId: 'region-1',
        manager: 'Patricia Russell',
        managerId: 'manager-6',
        memberCount: 22,
        activeSalespeople: 22,
        totalPoints: 285000,
        monthlyTarget: 200000,
        totalRevenue: 3650000,
        revenueTarget: 3000000,
        dealsCompleted: 115,
        avgPointsPerMember: 12954,
        campaignParticipation: 90,
        trainingCompletion: 85,
        pendingApprovals: 0,
        status: 'exceeding',
      },
      {
        id: 'team-7',
        name: 'Northeast Eta',
        regionId: 'region-1',
        manager: 'Deborah Wilson',
        managerId: 'manager-7',
        memberCount: 20,
        activeSalespeople: 20,
        totalPoints: 272000,
        monthlyTarget: 200000,
        totalRevenue: 4180000,
        revenueTarget: 3000000,
        dealsCompleted: 82,
        avgPointsPerMember: 13600,
        campaignParticipation: 93,
        trainingCompletion: 90,
        pendingApprovals: 2,
        status: 'exceeding',
      },
      {
        id: 'team-8',
        name: 'Northeast Theta',
        regionId: 'region-1',
        manager: 'George Morales',
        managerId: 'manager-8',
        memberCount: 21,
        activeSalespeople: 21,
        totalPoints: 309000,
        monthlyTarget: 200000,
        totalRevenue: 4210000,
        revenueTarget: 3000000,
        dealsCompleted: 89,
        avgPointsPerMember: 14714,
        campaignParticipation: 76,
        trainingCompletion: 60,
        pendingApprovals: 4,
        status: 'exceeding',
      },
      {
        id: 'team-9',
        name: 'Southeast Alpha',
        regionId: 'region-2',
        manager: 'Daniel White',
        managerId: 'manager-9',
        memberCount: 20,
        activeSalespeople: 20,
        totalPoints: 346000,
        monthlyTarget: 200000,
        totalRevenue: 4740000,
        revenueTarget: 3000000,
        dealsCompleted: 96,
        avgPointsPerMember: 17300,
        campaignParticipation: 79,
        trainingCompletion: 65,
        pendingApprovals: 1,
        status: 'exceeding',
      },
      {
        id: 'team-10',
        name: 'Southeast Beta',
        regionId: 'region-2',
        manager: 'Jessica Richardson',
        managerId: 'manager-10',
        memberCount: 21,
        activeSalespeople: 21,
        totalPoints: 333000,
        monthlyTarget: 200000,
        totalRevenue: 4770000,
        revenueTarget: 3000000,
        dealsCompleted: 103,
        avgPointsPerMember: 15857,
        campaignParticipation: 82,
        trainingCompletion: 70,
        pendingApprovals: 3,
        status: 'exceeding',
      },
      {
        id: 'team-11',
        name: 'Southeast Gamma',
        regionId: 'region-2',
        manager: 'Karen Morgan',
        managerId: 'manager-11',
        memberCount: 22,
        activeSalespeople: 22,
        totalPoints: 370000,
        monthlyTarget: 200000,
        totalRevenue: 5300000,
        revenueTarget: 3000000,
        dealsCompleted: 110,
        avgPointsPerMember: 16818,
        campaignParticipation: 85,
        trainingCompletion: 75,
        pendingApprovals: 0,
        status: 'exceeding',
      },
      {
        id: 'team-12',
        name: 'Southeast Delta',
        regionId: 'region-2',
        manager: 'Patricia Nguyen',
        managerId: 'manager-12',
        memberCount: 20,
        activeSalespeople: 20,
        totalPoints: 407000,
        monthlyTarget: 200000,
        totalRevenue: 5330000,
        revenueTarget: 3000000,
        dealsCompleted: 117,
        avgPointsPerMember: 20350,
        campaignParticipation: 88,
        trainingCompletion: 80,
        pendingApprovals: 2,
        status: 'exceeding',
      },
      {
        id: 'team-13',
        name: 'Southeast Epsilon',
        regionId: 'region-2',
        manager: 'Eric Edwards',
        managerId: 'manager-13',
        memberCount: 21,
        activeSalespeople: 21,
        totalPoints: 394000,
        monthlyTarget: 200000,
        totalRevenue: 5860000,
        revenueTarget: 3000000,
        dealsCompleted: 84,
        avgPointsPerMember: 18761,
        campaignParticipation: 91,
        trainingCompletion: 85,
        pendingApprovals: 4,
        status: 'exceeding',
      },
      {
        id: 'team-14',
        name: 'Southeast Zeta',
        regionId: 'region-2',
        manager: 'Ruth Morris',
        managerId: 'manager-14',
        memberCount: 22,
        activeSalespeople: 22,
        totalPoints: 431000,
        monthlyTarget: 200000,
        totalRevenue: 6390000,
        revenueTarget: 3000000,
        dealsCompleted: 91,
        avgPointsPerMember: 19590,
        campaignParticipation: 94,
        trainingCompletion: 90,
        pendingApprovals: 1,
        status: 'exceeding',
      },
      {
        id: 'team-15',
        name: 'Southeast Eta',
        regionId: 'region-2',
        manager: 'Samuel Lewis',
        managerId: 'manager-15',
        memberCount: 20,
        activeSalespeople: 20,
        totalPoints: 468000,
        monthlyTarget: 200000,
        totalRevenue: 6420000,
        revenueTarget: 3000000,
        dealsCompleted: 98,
        avgPointsPerMember: 23400,
        campaignParticipation: 77,
        trainingCompletion: 60,
        pendingApprovals: 3,
        status: 'exceeding',
      },
      {
        id: 'team-16',
        name: 'Southeast Theta',
        regionId: 'region-2',
        manager: 'Carol Howard',
        managerId: 'manager-16',
        memberCount: 21,
        activeSalespeople: 21,
        totalPoints: 455000,
        monthlyTarget: 200000,
        totalRevenue: 6950000,
        revenueTarget: 3000000,
        dealsCompleted: 105,
        avgPointsPerMember: 21666,
        campaignParticipation: 80,
        trainingCompletion: 65,
        pendingApprovals: 0,
        status: 'exceeding',
      },
      {
        id: 'team-17',
        name: 'Central Alpha',
        regionId: 'region-3',
        manager: 'Richard Adams',
        managerId: 'manager-17',
        memberCount: 20,
        activeSalespeople: 20,
        totalPoints: 492000,
        monthlyTarget: 200000,
        totalRevenue: 6980000,
        revenueTarget: 3000000,
        dealsCompleted: 112,
        avgPointsPerMember: 24600,
        campaignParticipation: 83,
        trainingCompletion: 70,
        pendingApprovals: 2,
        status: 'exceeding',
      },
      {
        id: 'team-18',
        name: 'Central Beta',
        regionId: 'region-3',
        manager: 'Christina Ortiz',
        managerId: 'manager-18',
        memberCount: 21,
        activeSalespeople: 21,
        totalPoints: 529000,
        monthlyTarget: 200000,
        totalRevenue: 7510000,
        revenueTarget: 3000000,
        dealsCompleted: 119,
        avgPointsPerMember: 25190,
        campaignParticipation: 86,
        trainingCompletion: 75,
        pendingApprovals: 4,
        status: 'exceeding',
      },
      {
        id: 'team-19',
        name: 'Central Gamma',
        regionId: 'region-3',
        manager: 'Christopher Alvarez',
        managerId: 'manager-19',
        memberCount: 22,
        activeSalespeople: 22,
        totalPoints: 516000,
        monthlyTarget: 200000,
        totalRevenue: 7540000,
        revenueTarget: 3000000,
        dealsCompleted: 86,
        avgPointsPerMember: 23454,
        campaignParticipation: 89,
        trainingCompletion: 80,
        pendingApprovals: 1,
        status: 'exceeding',
      },
      {
        id: 'team-20',
        name: 'Central Delta',
        regionId: 'region-3',
        manager: 'Kathleen Evans',
        managerId: 'manager-20',
        memberCount: 20,
        activeSalespeople: 20,
        totalPoints: 553000,
        monthlyTarget: 200000,
        totalRevenue: 8070000,
        revenueTarget: 3000000,
        dealsCompleted: 93,
        avgPointsPerMember: 27650,
        campaignParticipation: 92,
        trainingCompletion: 85,
        pendingApprovals: 3,
        status: 'exceeding',
      },
      {
        id: 'team-21',
        name: 'Central Epsilon',
        regionId: 'region-3',
        manager: 'Laura Ward',
        managerId: 'manager-21',
        memberCount: 21,
        activeSalespeople: 21,
        totalPoints: 590000,
        monthlyTarget: 200000,
        totalRevenue: 8100000,
        revenueTarget: 3000000,
        dealsCompleted: 100,
        avgPointsPerMember: 28095,
        campaignParticipation: 75,
        trainingCompletion: 90,
        pendingApprovals: 0,
        status: 'exceeding',
      },
      {
        id: 'team-22',
        name: 'Central Zeta',
        regionId: 'region-3',
        manager: 'Gary Anderson',
        managerId: 'manager-22',
        memberCount: 22,
        activeSalespeople: 22,
        totalPoints: 577000,
        monthlyTarget: 200000,
        totalRevenue: 8630000,
        revenueTarget: 3000000,
        dealsCompleted: 107,
        avgPointsPerMember: 26227,
        campaignParticipation: 78,
        trainingCompletion: 60,
        pendingApprovals: 2,
        status: 'exceeding',
      },
      {
        id: 'team-23',
        name: 'Central Eta',
        regionId: 'region-3',
        manager: 'Carol Roberts',
        managerId: 'manager-23',
        memberCount: 20,
        activeSalespeople: 20,
        totalPoints: 614000,
        monthlyTarget: 200000,
        totalRevenue: 8660000,
        revenueTarget: 3000000,
        dealsCompleted: 114,
        avgPointsPerMember: 30700,
        campaignParticipation: 81,
        trainingCompletion: 65,
        pendingApprovals: 4,
        status: 'exceeding',
      },
      {
        id: 'team-24',
        name: 'Central Theta',
        regionId: 'region-3',
        manager: 'Shirley Rodriguez',
        managerId: 'manager-24',
        memberCount: 21,
        activeSalespeople: 21,
        totalPoints: 651000,
        monthlyTarget: 200000,
        totalRevenue: 9190000,
        revenueTarget: 3000000,
        dealsCompleted: 81,
        avgPointsPerMember: 31000,
        campaignParticipation: 84,
        trainingCompletion: 70,
        pendingApprovals: 1,
        status: 'exceeding',
      },
      {
        id: 'team-25',
        name: 'Southwest Alpha',
        regionId: 'region-4',
        manager: 'Jacob Williams',
        managerId: 'manager-25',
        memberCount: 20,
        activeSalespeople: 20,
        totalPoints: 638000,
        monthlyTarget: 200000,
        totalRevenue: 9220000,
        revenueTarget: 3000000,
        dealsCompleted: 88,
        avgPointsPerMember: 31900,
        campaignParticipation: 87,
        trainingCompletion: 75,
        pendingApprovals: 3,
        status: 'exceeding',
      },
      {
        id: 'team-26',
        name: 'Southwest Beta',
        regionId: 'region-4',
        manager: 'Aaron Perry',
        managerId: 'manager-26',
        memberCount: 21,
        activeSalespeople: 21,
        totalPoints: 675000,
        monthlyTarget: 200000,
        totalRevenue: 9750000,
        revenueTarget: 3000000,
        dealsCompleted: 95,
        avgPointsPerMember: 32142,
        campaignParticipation: 90,
        trainingCompletion: 80,
        pendingApprovals: 0,
        status: 'exceeding',
      },
      {
        id: 'team-27',
        name: 'Southwest Gamma',
        regionId: 'region-4',
        manager: 'Amanda Harris',
        managerId: 'manager-27',
        memberCount: 22,
        activeSalespeople: 22,
        totalPoints: 712000,
        monthlyTarget: 200000,
        totalRevenue: 10280000,
        revenueTarget: 3000000,
        dealsCompleted: 102,
        avgPointsPerMember: 32363,
        campaignParticipation: 93,
        trainingCompletion: 85,
        pendingApprovals: 2,
        status: 'exceeding',
      },
      {
        id: 'team-28',
        name: 'Southwest Delta',
        regionId: 'region-4',
        manager: 'Sharon Myers',
        managerId: 'manager-28',
        memberCount: 20,
        activeSalespeople: 20,
        totalPoints: 699000,
        monthlyTarget: 200000,
        totalRevenue: 10310000,
        revenueTarget: 3000000,
        dealsCompleted: 109,
        avgPointsPerMember: 34950,
        campaignParticipation: 76,
        trainingCompletion: 90,
        pendingApprovals: 4,
        status: 'exceeding',
      },
      {
        id: 'team-29',
        name: 'Southwest Epsilon',
        regionId: 'region-4',
        manager: 'James Lopez',
        managerId: 'manager-29',
        memberCount: 21,
        activeSalespeople: 21,
        totalPoints: 736000,
        monthlyTarget: 200000,
        totalRevenue: 10840000,
        revenueTarget: 3000000,
        dealsCompleted: 116,
        avgPointsPerMember: 35047,
        campaignParticipation: 79,
        trainingCompletion: 60,
        pendingApprovals: 1,
        status: 'exceeding',
      },
      {
        id: 'team-30',
        name: 'Southwest Zeta',
        regionId: 'region-4',
        manager: 'Brandon Martinez',
        managerId: 'manager-30',
        memberCount: 22,
        activeSalespeople: 22,
        totalPoints: 773000,
        monthlyTarget: 200000,
        totalRevenue: 10870000,
        revenueTarget: 3000000,
        dealsCompleted: 83,
        avgPointsPerMember: 35136,
        campaignParticipation: 82,
        trainingCompletion: 65,
        pendingApprovals: 3,
        status: 'exceeding',
      },
      {
        id: 'team-31',
        name: 'Southwest Eta',
        regionId: 'region-4',
        manager: 'Robert Baker',
        managerId: 'manager-31',
        memberCount: 20,
        activeSalespeople: 20,
        totalPoints: 760000,
        monthlyTarget: 200000,
        totalRevenue: 11400000,
        revenueTarget: 3000000,
        dealsCompleted: 90,
        avgPointsPerMember: 38000,
        campaignParticipation: 85,
        trainingCompletion: 70,
        pendingApprovals: 0,
        status: 'exceeding',
      },
      {
        id: 'team-32',
        name: 'Southwest Theta',
        regionId: 'region-4',
        manager: 'William Baker',
        managerId: 'manager-32',
        memberCount: 21,
        activeSalespeople: 21,
        totalPoints: 797000,
        monthlyTarget: 200000,
        totalRevenue: 11430000,
        revenueTarget: 3000000,
        dealsCompleted: 97,
        avgPointsPerMember: 37952,
        campaignParticipation: 88,
        trainingCompletion: 75,
        pendingApprovals: 2,
        status: 'exceeding',
      },
      {
        id: 'team-33',
        name: 'West Alpha',
        regionId: 'region-5',
        manager: 'Barbara Myers',
        managerId: 'manager-33',
        memberCount: 20,
        activeSalespeople: 20,
        totalPoints: 834000,
        monthlyTarget: 200000,
        totalRevenue: 11960000,
        revenueTarget: 3000000,
        dealsCompleted: 104,
        avgPointsPerMember: 41700,
        campaignParticipation: 91,
        trainingCompletion: 80,
        pendingApprovals: 4,
        status: 'exceeding',
      },
      {
        id: 'team-34',
        name: 'West Beta',
        regionId: 'region-5',
        manager: 'Olivia Garcia',
        managerId: 'manager-34',
        memberCount: 21,
        activeSalespeople: 21,
        totalPoints: 821000,
        monthlyTarget: 200000,
        totalRevenue: 11990000,
        revenueTarget: 3000000,
        dealsCompleted: 111,
        avgPointsPerMember: 39095,
        campaignParticipation: 94,
        trainingCompletion: 85,
        pendingApprovals: 1,
        status: 'exceeding',
      },
      {
        id: 'team-35',
        name: 'West Gamma',
        regionId: 'region-5',
        manager: 'Christina Ward',
        managerId: 'manager-35',
        memberCount: 22,
        activeSalespeople: 22,
        totalPoints: 858000,
        monthlyTarget: 200000,
        totalRevenue: 12520000,
        revenueTarget: 3000000,
        dealsCompleted: 118,
        avgPointsPerMember: 39000,
        campaignParticipation: 77,
        trainingCompletion: 90,
        pendingApprovals: 3,
        status: 'exceeding',
      },
      {
        id: 'team-36',
        name: 'West Delta',
        regionId: 'region-5',
        manager: 'Jerry Carter',
        managerId: 'manager-36',
        memberCount: 20,
        activeSalespeople: 20,
        totalPoints: 895000,
        monthlyTarget: 200000,
        totalRevenue: 12550000,
        revenueTarget: 3000000,
        dealsCompleted: 85,
        avgPointsPerMember: 44750,
        campaignParticipation: 80,
        trainingCompletion: 60,
        pendingApprovals: 0,
        status: 'exceeding',
      },
      {
        id: 'team-37',
        name: 'West Epsilon',
        regionId: 'region-5',
        manager: 'Heather Collins',
        managerId: 'manager-37',
        memberCount: 21,
        activeSalespeople: 21,
        totalPoints: 882000,
        monthlyTarget: 200000,
        totalRevenue: 13080000,
        revenueTarget: 3000000,
        dealsCompleted: 92,
        avgPointsPerMember: 42000,
        campaignParticipation: 83,
        trainingCompletion: 65,
        pendingApprovals: 2,
        status: 'exceeding',
      },
      {
        id: 'team-38',
        name: 'West Zeta',
        regionId: 'region-5',
        manager: 'Brenda Clark',
        managerId: 'manager-38',
        memberCount: 22,
        activeSalespeople: 22,
        totalPoints: 919000,
        monthlyTarget: 200000,
        totalRevenue: 13110000,
        revenueTarget: 3000000,
        dealsCompleted: 99,
        avgPointsPerMember: 41772,
        campaignParticipation: 86,
        trainingCompletion: 70,
        pendingApprovals: 4,
        status: 'exceeding',
      },
      {
        id: 'team-39',
        name: 'West Eta',
        regionId: 'region-5',
        manager: 'Helen Robinson',
        managerId: 'manager-39',
        memberCount: 20,
        activeSalespeople: 20,
        totalPoints: 956000,
        monthlyTarget: 200000,
        totalRevenue: 13640000,
        revenueTarget: 3000000,
        dealsCompleted: 106,
        avgPointsPerMember: 47800,
        campaignParticipation: 89,
        trainingCompletion: 75,
        pendingApprovals: 1,
        status: 'exceeding',
      },
      {
        id: 'team-40',
        name: 'West Theta',
        regionId: 'region-5',
        manager: 'Laura Kim',
        managerId: 'manager-40',
        memberCount: 21,
        activeSalespeople: 21,
        totalPoints: 943000,
        monthlyTarget: 200000,
        totalRevenue: 14170000,
        revenueTarget: 3000000,
        dealsCompleted: 113,
        avgPointsPerMember: 44904,
        campaignParticipation: 92,
        trainingCompletion: 80,
        pendingApprovals: 3,
        status: 'exceeding',
      },
      {
        id: 'team-41',
        name: 'International Alpha',
        regionId: 'region-6',
        manager: 'Barbara Jenkins',
        managerId: 'manager-41',
        memberCount: 20,
        activeSalespeople: 20,
        totalPoints: 980000,
        monthlyTarget: 200000,
        totalRevenue: 14200000,
        revenueTarget: 3000000,
        dealsCompleted: 80,
        avgPointsPerMember: 49000,
        campaignParticipation: 75,
        trainingCompletion: 85,
        pendingApprovals: 0,
        status: 'exceeding',
      },
      {
        id: 'team-42',
        name: 'International Beta',
        regionId: 'region-6',
        manager: 'Nathan Ward',
        managerId: 'manager-42',
        memberCount: 21,
        activeSalespeople: 21,
        totalPoints: 1017000,
        monthlyTarget: 200000,
        totalRevenue: 14730000,
        revenueTarget: 3000000,
        dealsCompleted: 87,
        avgPointsPerMember: 48428,
        campaignParticipation: 78,
        trainingCompletion: 90,
        pendingApprovals: 2,
        status: 'exceeding',
      },
      {
        id: 'team-43',
        name: 'International Gamma',
        regionId: 'region-6',
        manager: 'Nicholas Richardson',
        managerId: 'manager-43',
        memberCount: 22,
        activeSalespeople: 22,
        totalPoints: 1004000,
        monthlyTarget: 200000,
        totalRevenue: 14760000,
        revenueTarget: 3000000,
        dealsCompleted: 94,
        avgPointsPerMember: 45636,
        campaignParticipation: 81,
        trainingCompletion: 60,
        pendingApprovals: 4,
        status: 'exceeding',
      },
      {
        id: 'team-44',
        name: 'International Delta',
        regionId: 'region-6',
        manager: 'Jacob Lewis',
        managerId: 'manager-44',
        memberCount: 20,
        activeSalespeople: 20,
        totalPoints: 1041000,
        monthlyTarget: 200000,
        totalRevenue: 15290000,
        revenueTarget: 3000000,
        dealsCompleted: 101,
        avgPointsPerMember: 52050,
        campaignParticipation: 84,
        trainingCompletion: 65,
        pendingApprovals: 1,
        status: 'exceeding',
      },
      {
        id: 'team-45',
        name: 'International Epsilon',
        regionId: 'region-6',
        manager: 'Daniel Thompson',
        managerId: 'manager-45',
        memberCount: 21,
        activeSalespeople: 21,
        totalPoints: 1078000,
        monthlyTarget: 200000,
        totalRevenue: 15320000,
        revenueTarget: 3000000,
        dealsCompleted: 108,
        avgPointsPerMember: 51333,
        campaignParticipation: 87,
        trainingCompletion: 70,
        pendingApprovals: 3,
        status: 'exceeding',
      },
      {
        id: 'team-46',
        name: 'International Zeta',
        regionId: 'region-6',
        manager: 'Jessica Hill',
        managerId: 'manager-46',
        memberCount: 22,
        activeSalespeople: 22,
        totalPoints: 1065000,
        monthlyTarget: 200000,
        totalRevenue: 15850000,
        revenueTarget: 3000000,
        dealsCompleted: 115,
        avgPointsPerMember: 48409,
        campaignParticipation: 90,
        trainingCompletion: 75,
        pendingApprovals: 0,
        status: 'exceeding',
      },
      {
        id: 'team-47',
        name: 'International Eta',
        regionId: 'region-6',
        manager: 'Benjamin Cox',
        managerId: 'manager-47',
        memberCount: 20,
        activeSalespeople: 20,
        totalPoints: 1102000,
        monthlyTarget: 200000,
        totalRevenue: 15880000,
        revenueTarget: 3000000,
        dealsCompleted: 82,
        avgPointsPerMember: 55100,
        campaignParticipation: 93,
        trainingCompletion: 80,
        pendingApprovals: 2,
        status: 'exceeding',
      },
      {
        id: 'team-48',
        name: 'International Theta',
        regionId: 'region-6',
        manager: 'Alexander Morgan',
        managerId: 'manager-48',
        memberCount: 21,
        activeSalespeople: 21,
        totalPoints: 1139000,
        monthlyTarget: 200000,
        totalRevenue: 16410000,
        revenueTarget: 3000000,
        dealsCompleted: 89,
        avgPointsPerMember: 54238,
        campaignParticipation: 76,
        trainingCompletion: 85,
        pendingApprovals: 4,
        status: 'exceeding',
      },
    ],
    totalMembers: 1002,
    totalTeams: 48,
    totalRegions: 6,
    totalPoints: 30936000,
    totalRevenue: 446340000,
    totalTarget: 9600000,
    totalRevenueTarget: 144000000,
    attainmentPercent: 322,
    revenueAttainment: 310,
    avgCampaignParticipation: 85,
    totalPendingApprovals: 96,
    teamsExceeding: 46,
    teamsNeedingAttention: 1,
    pointsByActivity: [
      {
        name: 'Campaigns',
        value: 12374400,
        color: '#3b82f6',
      },
      {
        name: 'Bonuses',
        value: 7734000,
        color: '#10b981',
      },
      {
        name: 'Milestones',
        value: 6187200,
        color: '#f59e0b',
      },
      {
        name: 'Spot Awards',
        value: 4640400,
        color: '#8b5cf6',
      },
    ],
    tierDistribution: [
      {
        tier: 'Bronze',
        members: 301,
        points: 5576025,
        avgPoints: 18525,
      },
      {
        tier: 'Silver',
        members: 351,
        points: 8669349,
        avgPoints: 24699,
      },
      {
        tier: 'Gold',
        members: 251,
        points: 9299299,
        avgPoints: 37049,
      },
      {
        tier: 'Platinum',
        members: 100,
        points: 6174900,
        avgPoints: 61749,
      },
    ],
  },
  activeParticipants: 952,
  totalMembers: 1002,
  topRewards: [
    {
      id: '1',
      name: 'Wireless Headphones',
      category: 'Electronics',
      timesRedeemed: 411,
      totalPoints: 2054100,
    },
    {
      id: '4',
      name: 'Spa Treatment',
      category: 'Experiences',
      timesRedeemed: 80,
      totalPoints: 1603200,
    },
    {
      id: '2',
      name: 'Smartwatch',
      category: 'Electronics',
      timesRedeemed: 251,
      totalPoints: 1565625,
    },
    {
      id: '3',
      name: 'Luxury Watch',
      category: 'Merchandise',
      timesRedeemed: 120,
      totalPoints: 1052100,
    },
    {
      id: '5',
      name: 'Designer Handbag',
      category: 'Merchandise',
      timesRedeemed: 150,
      totalPoints: 826650,
    },
  ],
  manualAdjustments: [
    {
      id: '1',
      user: 'Olivia Murphy',
      requestedBy: 'Marcus Hayes (Manager)',
      points: 5000,
      reason: 'Exceptional Sentri-7 product knowledge certification',
      status: 'pending',
      date: '2026-02-05',
    },
    {
      id: '2',
      user: 'Michael Chen',
      requestedBy: 'Marcus Hayes (Manager)',
      points: -2000,
      reason: 'Points correction - duplicate entry',
      status: 'pending',
      date: '2026-02-04',
    },
    {
      id: '3',
      user: 'Emma Williams',
      requestedBy: 'Marcus Hayes (Manager)',
      points: 3000,
      reason: 'Team leadership during Sentri-7 launch',
      status: 'pending',
      date: '2026-02-03',
    },
    {
      id: '4',
      user: 'James Wilson',
      requestedBy: 'System',
      points: 1500,
      reason: 'Bonus points for mentoring new team members',
      status: 'pending',
      date: '2026-02-02',
    },
    {
      id: '5',
      user: 'Olivia Murphy',
      requestedBy: 'Marcus Hayes (Manager)',
      points: 2500,
      reason: 'Peer mentor reward for Sentri-7 launch',
      status: 'pending',
      date: '2026-02-01',
    },
  ],
  // regional manager
  region: {
    id: 'region-1',
    name: 'Northeast',
    managerId: 'rm-1',
  },
  totalPoints: 1886000,
  totalRevenue: 26340000,
  avgCampaignParticipation: 83,
  showDiscretionaryBank: true,
  escalatedApprovals: [],
  teamPerformanceData: [
    {
      team: 'Theta',
      points: 309,
      target: 200,
      attainment: 155,
    },
    {
      team: 'Zeta',
      points: 285,
      target: 200,
      attainment: 143,
    },
    {
      team: 'Eta',
      points: 272,
      target: 200,
      attainment: 136,
    },
    {
      team: 'Epsilon',
      points: 248,
      target: 200,
      attainment: 124,
    },
    {
      team: 'Gamma',
      points: 224,
      target: 200,
      attainment: 112,
    },
    {
      team: 'Delta',
      points: 211,
      target: 200,
      attainment: 106,
    },
    {
      team: 'Beta',
      points: 187,
      target: 200,
      attainment: 94,
    },
    {
      team: 'Alpha',
      points: 150,
      target: 200,
      attainment: 75,
    },
  ],
  pointsByActivity: [
    {
      name: 'Campaigns',
      value: 754400,
      color: '#3b82f6',
    },
    {
      name: 'Bonuses',
      value: 471500,
      color: '#10b981',
    },
    {
      name: 'Milestones',
      value: 377200,
      color: '#f59e0b',
    },
    {
      name: 'Spot Awards',
      value: 282900,
      color: '#8b5cf6',
    },
  ],
  managerMetrics: [
    {
      name: 'George Morales',
      team: 'Theta',
      teamAttainment: 155,
      campaignAdoption: 76,
      trainingCompletion: 60,
    },
    {
      name: 'Patricia Russell',
      team: 'Zeta',
      teamAttainment: 143,
      campaignAdoption: 90,
      trainingCompletion: 85,
    },
    {
      name: 'Deborah Wilson',
      team: 'Eta',
      teamAttainment: 136,
      campaignAdoption: 93,
      trainingCompletion: 90,
    },
    {
      name: 'Christopher Martin',
      team: 'Epsilon',
      teamAttainment: 124,
      campaignAdoption: 87,
      trainingCompletion: 80,
    },
    {
      name: 'Dorothy Diaz',
      team: 'Gamma',
      teamAttainment: 112,
      campaignAdoption: 81,
      trainingCompletion: 70,
    },
    {
      name: 'Raymond Morgan',
      team: 'Delta',
      teamAttainment: 106,
      campaignAdoption: 84,
      trainingCompletion: 75,
    },
    {
      name: 'Virginia White',
      team: 'Beta',
      teamAttainment: 94,
      campaignAdoption: 78,
      trainingCompletion: 65,
    },
    {
      name: 'Marcus Hayes',
      team: 'Alpha',
      teamAttainment: 75,
      campaignAdoption: 75,
      trainingCompletion: 60,
    },
  ],
  teamData: [
    {
      id: 'team-8',
      name: 'Northeast Theta',
      regionId: 'region-1',
      manager: 'George Morales',
      managerId: 'manager-8',
      memberCount: 21,
      activeSalespeople: 21,
      totalPoints: 309000,
      monthlyTarget: 200000,
      totalRevenue: 4210000,
      revenueTarget: 3000000,
      dealsCompleted: 89,
      avgPointsPerMember: 14714,
      campaignParticipation: 76,
      trainingCompletion: 60,
      pendingApprovals: 4,
      status: 'exceeding',
    },
    {
      id: 'team-6',
      name: 'Northeast Zeta',
      regionId: 'region-1',
      manager: 'Patricia Russell',
      managerId: 'manager-6',
      memberCount: 22,
      activeSalespeople: 22,
      totalPoints: 285000,
      monthlyTarget: 200000,
      totalRevenue: 3650000,
      revenueTarget: 3000000,
      dealsCompleted: 115,
      avgPointsPerMember: 12954,
      campaignParticipation: 90,
      trainingCompletion: 85,
      pendingApprovals: 0,
      status: 'exceeding',
    },
    {
      id: 'team-7',
      name: 'Northeast Eta',
      regionId: 'region-1',
      manager: 'Deborah Wilson',
      managerId: 'manager-7',
      memberCount: 20,
      activeSalespeople: 20,
      totalPoints: 272000,
      monthlyTarget: 200000,
      totalRevenue: 4180000,
      revenueTarget: 3000000,
      dealsCompleted: 82,
      avgPointsPerMember: 13600,
      campaignParticipation: 93,
      trainingCompletion: 90,
      pendingApprovals: 2,
      status: 'exceeding',
    },
    {
      id: 'team-5',
      name: 'Northeast Epsilon',
      regionId: 'region-1',
      manager: 'Christopher Martin',
      managerId: 'manager-5',
      memberCount: 21,
      activeSalespeople: 21,
      totalPoints: 248000,
      monthlyTarget: 200000,
      totalRevenue: 3620000,
      revenueTarget: 3000000,
      dealsCompleted: 108,
      avgPointsPerMember: 11809,
      campaignParticipation: 87,
      trainingCompletion: 80,
      pendingApprovals: 3,
      status: 'exceeding',
    },
    {
      id: 'team-3',
      name: 'Northeast Gamma',
      regionId: 'region-1',
      manager: 'Dorothy Diaz',
      managerId: 'manager-3',
      memberCount: 22,
      activeSalespeople: 22,
      totalPoints: 224000,
      monthlyTarget: 200000,
      totalRevenue: 3060000,
      revenueTarget: 3000000,
      dealsCompleted: 94,
      avgPointsPerMember: 10181,
      campaignParticipation: 81,
      trainingCompletion: 70,
      pendingApprovals: 4,
      status: 'exceeding',
    },
    {
      id: 'team-4',
      name: 'Northeast Delta',
      regionId: 'region-1',
      manager: 'Raymond Morgan',
      managerId: 'manager-4',
      memberCount: 20,
      activeSalespeople: 20,
      totalPoints: 211000,
      monthlyTarget: 200000,
      totalRevenue: 3090000,
      revenueTarget: 3000000,
      dealsCompleted: 101,
      avgPointsPerMember: 10550,
      campaignParticipation: 84,
      trainingCompletion: 75,
      pendingApprovals: 1,
      status: 'exceeding',
    },
    {
      id: 'team-2',
      name: 'Northeast Beta',
      regionId: 'region-1',
      manager: 'Virginia White',
      managerId: 'manager-2',
      memberCount: 21,
      activeSalespeople: 21,
      totalPoints: 187000,
      monthlyTarget: 200000,
      totalRevenue: 2530000,
      revenueTarget: 3000000,
      dealsCompleted: 87,
      avgPointsPerMember: 8904,
      campaignParticipation: 78,
      trainingCompletion: 65,
      pendingApprovals: 2,
      status: 'on_track',
    },
    {
      id: 'team-1',
      name: 'Northeast Alpha',
      regionId: 'region-1',
      manager: 'Marcus Hayes',
      managerId: 'manager-1',
      memberCount: 20,
      activeSalespeople: 20,
      totalPoints: 150000,
      monthlyTarget: 200000,
      totalRevenue: 2000000,
      revenueTarget: 3000000,
      dealsCompleted: 80,
      avgPointsPerMember: 7500,
      campaignParticipation: 75,
      trainingCompletion: 60,
      pendingApprovals: 0,
      status: 'needs_attention',
    },
  ],
  selectedTeam: null,

  summary: {
    totalRevenue: 1916889,
    totalPoints: 865716,
    totalUnits: 808,
    totalDealers: 12,
    totalLocations: 30,
    totalDistributors: 4,
    avgPointsPerDealer: 72143,
    avgRevenuePerDealer: 159741,
  },
  distributorMetrics: [
    {
      distributor: {
        id: 'cam-1',
        name: 'Catherine Morales',
        role: 'channel_account_manager',
        initials: 'CM',
        programType: 'channel',
        managedTerritoryIds: ['territory-1', 'territory-2', 'territory-3'],
      },
      perf: {
        distributorId: 'cam-1',
        distributorName: 'Catherine Morales',
        accountCount: 3,
        totalRevenue: 690498,
        totalPoints: 304482,
        totalUnits: 261,
        revenueChange: 6,
      },
    },
    {
      distributor: {
        id: 'cam-2',
        name: 'Kathleen Baker',
        role: 'channel_account_manager',
        initials: 'KB',
        programType: 'channel',
        managedTerritoryIds: ['territory-4', 'territory-5', 'territory-1'],
      },
      perf: {
        distributorId: 'cam-2',
        distributorName: 'Kathleen Baker',
        accountCount: 3,
        totalRevenue: 433772,
        totalPoints: 226567,
        totalUnits: 225,
        revenueChange: 6,
      },
    },
    {
      distributor: {
        id: 'cam-3',
        name: 'Samuel Smith',
        role: 'channel_account_manager',
        initials: 'SS',
        programType: 'channel',
        managedTerritoryIds: ['territory-2', 'territory-3', 'territory-4'],
      },
      perf: {
        distributorId: 'cam-3',
        distributorName: 'Samuel Smith',
        accountCount: 3,
        totalRevenue: 361341,
        totalPoints: 180357,
        totalUnits: 117,
        revenueChange: 4,
      },
    },
    {
      distributor: {
        id: 'cam-4',
        name: 'Jerry Roberts',
        role: 'channel_account_manager',
        initials: 'JR',
        programType: 'channel',
        managedTerritoryIds: ['territory-5', 'territory-1', 'territory-2'],
      },
      perf: {
        distributorId: 'cam-4',
        distributorName: 'Jerry Roberts',
        accountCount: 3,
        totalRevenue: 431278,
        totalPoints: 154310,
        totalUnits: 205,
        revenueChange: 11,
      },
    },
  ],
  maxDistRevenue: 690498,
  leaderboard: [
    {
      dealerId: 'dealer-3',
      dealerName: 'Northern Drive Group',
      points: 109085,
      tier: 'Gold',
      revenue: 247547,
    },
    {
      dealerId: 'dealer-1',
      dealerName: 'Apex Auto Group',
      points: 106740,
      tier: 'Gold',
      revenue: 201814,
    },
    {
      dealerId: 'dealer-6',
      dealerName: 'Heartland Auto Supply',
      points: 93214,
      tier: 'Gold',
      revenue: 173855,
    },
    {
      dealerId: 'dealer-4',
      dealerName: 'Velocity Service Network',
      points: 88845,
      tier: 'Gold',
      revenue: 188850,
    },
    {
      dealerId: 'dealer-2',
      dealerName: 'Summit Parts Network',
      points: 88657,
      tier: 'Gold',
      revenue: 241137,
    },
    {
      dealerId: 'dealer-11',
      dealerName: 'Mountain View Service',
      points: 67079,
      tier: 'Gold',
      revenue: 134206,
    },
    {
      dealerId: 'dealer-8',
      dealerName: 'Pinnacle Parts Plus',
      points: 64793,
      tier: 'Gold',
      revenue: 146514,
    },
    {
      dealerId: 'dealer-7',
      dealerName: 'Atlantic Service Centers',
      points: 59264,
      tier: 'Gold',
      revenue: 96969,
    },
    {
      dealerId: 'dealer-9',
      dealerName: 'Frontier Brake Specialists',
      points: 56300,
      tier: 'Gold',
      revenue: 117858,
    },
    {
      dealerId: 'dealer-10',
      dealerName: 'Coastal Auto Partners',
      points: 49947,
      tier: 'Silver',
      revenue: 150137,
    },
    {
      dealerId: 'dealer-5',
      dealerName: 'Pacific Brake Partners',
      points: 44508,
      tier: 'Silver',
      revenue: 71067,
    },
    {
      dealerId: 'dealer-12',
      dealerName: 'Great Lakes Parts Supply',
      points: 37284,
      tier: 'Silver',
      revenue: 146935,
    },
  ],
  dealerMetrics: [
    {
      dealer: {
        id: 'dealer-1',
        name: 'Apex Auto Group',
        territory: 'territory-1',
        channelAccountManagerId: 'cam-1',
        locationCount: 3,
      },
      perf: {
        dealerId: 'dealer-1',
        totalPoints: 106740,
        monthlyRevenue: 201814,
        revenueChange: 7,
        monthlyPoints: 14968,
        unitsSold: 89,
        tier: 'Gold',
        storeCount: 3,
      },
    },
    {
      dealer: {
        id: 'dealer-2',
        name: 'Summit Parts Network',
        territory: 'territory-2',
        channelAccountManagerId: 'cam-1',
        locationCount: 3,
      },
      perf: {
        dealerId: 'dealer-2',
        totalPoints: 88657,
        monthlyRevenue: 241137,
        revenueChange: 10,
        monthlyPoints: 16399,
        unitsSold: 88,
        tier: 'Gold',
        storeCount: 3,
      },
    },
    {
      dealer: {
        id: 'dealer-3',
        name: 'Northern Drive Group',
        territory: 'territory-3',
        channelAccountManagerId: 'cam-1',
        locationCount: 3,
      },
      perf: {
        dealerId: 'dealer-3',
        totalPoints: 109085,
        monthlyRevenue: 247547,
        revenueChange: 0,
        monthlyPoints: 10738,
        unitsSold: 84,
        tier: 'Gold',
        storeCount: 3,
      },
    },
    {
      dealer: {
        id: 'dealer-4',
        name: 'Velocity Service Network',
        territory: 'territory-4',
        channelAccountManagerId: 'cam-2',
        locationCount: 3,
      },
      perf: {
        dealerId: 'dealer-4',
        totalPoints: 88845,
        monthlyRevenue: 188850,
        revenueChange: 15,
        monthlyPoints: 15907,
        unitsSold: 74,
        tier: 'Gold',
        storeCount: 3,
      },
    },
    {
      dealer: {
        id: 'dealer-5',
        name: 'Pacific Brake Partners',
        territory: 'territory-5',
        channelAccountManagerId: 'cam-2',
        locationCount: 3,
      },
      perf: {
        dealerId: 'dealer-5',
        totalPoints: 44508,
        monthlyRevenue: 71067,
        revenueChange: 11,
        monthlyPoints: 16304,
        unitsSold: 55,
        tier: 'Silver',
        storeCount: 3,
      },
    },
    {
      dealer: {
        id: 'dealer-6',
        name: 'Heartland Auto Supply',
        territory: 'territory-1',
        channelAccountManagerId: 'cam-2',
        locationCount: 3,
      },
      perf: {
        dealerId: 'dealer-6',
        totalPoints: 93214,
        monthlyRevenue: 173855,
        revenueChange: -8,
        monthlyPoints: 19201,
        unitsSold: 96,
        tier: 'Gold',
        storeCount: 3,
      },
    },
    {
      dealer: {
        id: 'dealer-7',
        name: 'Atlantic Service Centers',
        territory: 'territory-2',
        channelAccountManagerId: 'cam-3',
        locationCount: 2,
      },
      perf: {
        dealerId: 'dealer-7',
        totalPoints: 59264,
        monthlyRevenue: 96969,
        revenueChange: -5,
        monthlyPoints: 12753,
        unitsSold: 36,
        tier: 'Gold',
        storeCount: 2,
      },
    },
    {
      dealer: {
        id: 'dealer-8',
        name: 'Pinnacle Parts Plus',
        territory: 'territory-3',
        channelAccountManagerId: 'cam-3',
        locationCount: 2,
      },
      perf: {
        dealerId: 'dealer-8',
        totalPoints: 64793,
        monthlyRevenue: 146514,
        revenueChange: 19,
        monthlyPoints: 11317,
        unitsSold: 46,
        tier: 'Gold',
        storeCount: 2,
      },
    },
    {
      dealer: {
        id: 'dealer-9',
        name: 'Frontier Brake Specialists',
        territory: 'territory-4',
        channelAccountManagerId: 'cam-3',
        locationCount: 2,
      },
      perf: {
        dealerId: 'dealer-9',
        totalPoints: 56300,
        monthlyRevenue: 117858,
        revenueChange: -2,
        monthlyPoints: 12254,
        unitsSold: 35,
        tier: 'Gold',
        storeCount: 2,
      },
    },
    {
      dealer: {
        id: 'dealer-10',
        name: 'Coastal Auto Partners',
        territory: 'territory-5',
        channelAccountManagerId: 'cam-4',
        locationCount: 2,
      },
      perf: {
        dealerId: 'dealer-10',
        totalPoints: 49947,
        monthlyRevenue: 150137,
        revenueChange: -1,
        monthlyPoints: 5248,
        unitsSold: 59,
        tier: 'Silver',
        storeCount: 2,
      },
    },
    {
      dealer: {
        id: 'dealer-11',
        name: 'Mountain View Service',
        territory: 'territory-1',
        channelAccountManagerId: 'cam-4',
        locationCount: 2,
      },
      perf: {
        dealerId: 'dealer-11',
        totalPoints: 67079,
        monthlyRevenue: 134206,
        revenueChange: 17,
        monthlyPoints: 13729,
        unitsSold: 75,
        tier: 'Gold',
        storeCount: 2,
      },
    },
    {
      dealer: {
        id: 'dealer-12',
        name: 'Great Lakes Parts Supply',
        territory: 'territory-2',
        channelAccountManagerId: 'cam-4',
        locationCount: 2,
      },
      perf: {
        dealerId: 'dealer-12',
        totalPoints: 37284,
        monthlyRevenue: 146935,
        revenueChange: 18,
        monthlyPoints: 8753,
        unitsSold: 71,
        tier: 'Silver',
        storeCount: 2,
      },
    },
  ],

  totalLocations: 9,
  totalUnits: 261,
  maxRevenue: 247547,
  dealersNeedingAttention: [],
}

export const PAW_MOCK_DATA_BY_ROLE: Record<string, any> = {
  sales: {
    tier_progress: {
      current: 45250,
      target: 50000,
      currentTier: 'Silver',
      nextTier: 'Gold',
    },
    performance: [
      {
        title: 'Total Points Earned',
        value: 42550,
        subtitle: '78450 lifetime',
      },
      {
        title: 'Points Redeemed',
        value: 12000,
        subtitle: '45,200 lifetime',
      },
      {
        title: 'This Month',
        value: 8450,
        subtitle: '+15.3% vs last month',
      },
      {
        title: 'Leaderboard Position',
        value: 3,
        subtitle: 'Up 5 spots from last month',
      },
    ],
    promotions: [
      {
        title: "President's Club Sprint",
        description: 'Secure 10 new Sentri-7 unit placements',
        pointsAwarded: 10000,
        deadline: format(
          new Date(Date.now() + 90 * 24 * 60 * 60 * 1000),
          'MMM dd, yyyy',
        ),
        daysRemaining: 90,
        current: 6,
        target: 10,
      },
      {
        title: 'Sentri-7 Specialist',
        description: 'Complete all advanced patient monitor certifications',
        pointsAwarded: 3000,
        deadline: format(
          new Date(Date.now() + 45 * 24 * 60 * 60 * 1000),
          'MMM dd, yyyy',
        ),
        daysRemaining: 45,
        current: 1,
        target: 2,
      },
      {
        title: 'Clinical Excellence',
        description: 'Conduct 5 successful Sentri-7 clinical trials',
        pointsAwarded: 5000,
        deadline: format(
          new Date(Date.now() + 120 * 24 * 60 * 60 * 1000),
          'MMM dd, yyyy',
        ),
        daysRemaining: 120,
        current: 2,
        target: 5,
      },
    ],
    sales: {
      individual_sales: [
        {
          rank: 1,
          name: 'Sarah Johnson',
          points: 52400,
          rankChange: 2,
          testIdPrefix: 'individual',
        },
        {
          rank: 2,
          name: 'Michael Chen',
          points: 48950,
          rankChange: -1,
          testIdPrefix: 'individual',
        },
        {
          rank: 3,
          name: 'Emma Williams',
          points: 45600,
          rankChange: 1,
          testIdPrefix: 'individual',
        },
        {
          rank: 4,
          name: 'Olivia Murphy',
          points: 33250,
          rankChange: 5,
          isCurrentUser: true,
          testIdPrefix: 'individual',
        },
        {
          rank: 5,
          name: 'Jessica Harris',
          points: 32400,
          rankChange: -2,
          testIdPrefix: 'individual',
        },
      ],
      department_sales: [
        {
          rank: 1,
          name: 'West Region',
          points: 5850000,
          rankChange: 1,
          testIdPrefix: 'individual',
        },
        {
          rank: 2,
          name: 'Northeast Region (Your Region)',
          points: 5620000,
          rankChange: -1,
          isCurrentUser: true,
          testIdPrefix: 'individual',
        },
        {
          rank: 3,
          name: 'Southeast Region',
          points: 5480000,
          rankChange: 2,
          testIdPrefix: 'individual',
        },
        {
          rank: 4,
          name: 'Central Region',
          points: 5290000,
          rankChange: -1,
          testIdPrefix: 'individual',
        },
        {
          rank: 5,
          name: 'Southwest Region',
          points: 5150000,
          rankChange: 1,
          testIdPrefix: 'individual',
        },
      ],
    },
    'earning-history': [
      {
        id: '1',
        date: format(new Date(), 'yyyy-MM-dd'),
        activity: 'Sentri-7 Certification Completion',
        points: 1500,
      },
      {
        id: '2',
        date: format(
          new Date(Date.now() - 2 * 24 * 60 * 60 * 1000),
          'yyyy-MM-dd',
        ),
        activity: 'CRM Sync: Sentri-7 Contract - Acme Health',
        points: 3750,
      },
      {
        id: '3',
        date: format(
          new Date(Date.now() - 5 * 24 * 60 * 60 * 1000),
          'yyyy-MM-dd',
        ),
        activity: 'Recognition Award from Marcus Hayes',
        points: 1000,
      },
      {
        id: '4',
        date: format(
          new Date(Date.now() - 10 * 24 * 60 * 60 * 1000),
          'yyyy-MM-dd',
        ),
        activity: 'Sentri-7 Early Adopter Bonus',
        points: 2500,
      },
      {
        id: '5',
        date: '2026-01-20',
        activity: 'Monthly Sales Target Achieved',
        points: 3000,
      },
      {
        id: '6',
        date: '2026-01-15',
        activity: 'New Customer Acquisition Bonus',
        points: 1500,
      },
      {
        id: '7',
        date: '2026-01-10',
        activity: 'Product Training Completion',
        points: 500,
      },
      {
        id: '8',
        date: '2026-01-05',
        activity: 'Weekly Sales Target',
        points: 800,
      },
    ],
  },
  program_admin: {
    overview: [
      {
        title: 'Total Team Members',
        value: 1002,
        subtitle: `6 regions • 48 teams`,
      },
      {
        title: 'Total Points Earned (YTD)',
        value: '309.4M',
        subtitle: '+14% vs last year',
      },
      {
        title: 'Total Revenue',
        value: '$4463M',
        subtitle: '+11% vs last year',
      },
      {
        title: 'Total Sales (YTD)',
        value: 39078,
        subtitle: '+10% vs last year',
      },
      {
        title: 'Active Promotions',
        value: 8,
      },
      {
        title: 'Acerage Points/Member (YTD)',
        value: 308743,
        subtitle: '+14% vs last year',
      },
    ],
    goals: {
      annual: {
        revenue: 5356080000,
        salesCount: 50100,
        points: 355764000,
      },
      ytdTotals: {
        points: 309360000,
        revenue: 4463400000,
        salesCount: 39078,
      },
      q4Totals: {
        revenue: 1472922000,
        salesCount: 14028,
        points: 97448400,
      },
    },
    'comparison-charts': [
      {
        type: 'bar',
        title: 'Points by Region (This Month)',
        dataKey: 'name',
        data: [
          {
            name: 'International',
            points: 8426,
            target: 1600,
            revenue: 122,
            attainment: 527,
          },
          {
            name: 'West',
            points: 7108,
            target: 1600,
            revenue: 103,
            attainment: 444,
          },
          {
            name: 'Southwest',
            points: 5790,
            target: 1600,
            revenue: 84,
            attainment: 362,
          },
          {
            name: 'Central',
            points: 4522,
            target: 1600,
            revenue: 65,
            attainment: 283,
          },
          {
            name: 'Southeast',
            points: 3204,
            target: 1600,
            revenue: 46,
            attainment: 200,
          },
          {
            name: 'Northeast',
            points: 1886,
            target: 1600,
            revenue: 26,
            attainment: 118,
          },
        ],
      },
    ],
    engagement: {
      activeParticipants: 952,
      totalMembers: 1002,
      tierDistribution: [
        {
          tier: 'Bronze',
          members: 301,
          points: 5576025,
          avgPoints: 18525,
        },
        {
          tier: 'Silver',
          members: 351,
          points: 8669349,
          avgPoints: 24699,
        },
        {
          tier: 'Gold',
          members: 251,
          points: 9299299,
          avgPoints: 37049,
        },
        {
          tier: 'Platinum',
          members: 100,
          points: 6174900,
          avgPoints: 61749,
        },
      ],
      topRewards: [
        {
          id: '1',
          name: 'Wireless Headphones',
          category: 'Electronics',
          timesRedeemed: 411,
          totalPoints: 2054100,
        },
        {
          id: '4',
          name: 'Spa Treatment',
          category: 'Experiences',
          timesRedeemed: 80,
          totalPoints: 1603200,
        },
        {
          id: '2',
          name: 'Smartwatch',
          category: 'Electronics',
          timesRedeemed: 251,
          totalPoints: 1565625,
        },
        {
          id: '3',
          name: 'Luxury Watch',
          category: 'Merchandise',
          timesRedeemed: 120,
          totalPoints: 1052100,
        },
        {
          id: '5',
          name: 'Designer Handbag',
          category: 'Merchandise',
          timesRedeemed: 150,
          totalPoints: 826650,
        },
      ],
    },
    leaderboard: [
      {
        id: 'region-6',
        name: 'International',
        managerId: 'rm-6',
        teams: [
          {
            id: 'team-41',
            name: 'International Alpha',
            regionId: 'region-6',
            manager: 'Barbara Jenkins',
            managerId: 'manager-41',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 980000,
            monthlyTarget: 200000,
            totalRevenue: 14200000,
            revenueTarget: 3000000,
            dealsCompleted: 80,
            avgPointsPerMember: 49000,
            campaignParticipation: 75,
            trainingCompletion: 85,
            pendingApprovals: 0,
            status: 'exceeding',
          },
          {
            id: 'team-42',
            name: 'International Beta',
            regionId: 'region-6',
            manager: 'Nathan Ward',
            managerId: 'manager-42',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 1017000,
            monthlyTarget: 200000,
            totalRevenue: 14730000,
            revenueTarget: 3000000,
            dealsCompleted: 87,
            avgPointsPerMember: 48428,
            campaignParticipation: 78,
            trainingCompletion: 90,
            pendingApprovals: 2,
            status: 'exceeding',
          },
          {
            id: 'team-43',
            name: 'International Gamma',
            regionId: 'region-6',
            manager: 'Nicholas Richardson',
            managerId: 'manager-43',
            memberCount: 22,
            activeSalespeople: 22,
            totalPoints: 1004000,
            monthlyTarget: 200000,
            totalRevenue: 14760000,
            revenueTarget: 3000000,
            dealsCompleted: 94,
            avgPointsPerMember: 45636,
            campaignParticipation: 81,
            trainingCompletion: 60,
            pendingApprovals: 4,
            status: 'exceeding',
          },
          {
            id: 'team-44',
            name: 'International Delta',
            regionId: 'region-6',
            manager: 'Jacob Lewis',
            managerId: 'manager-44',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 1041000,
            monthlyTarget: 200000,
            totalRevenue: 15290000,
            revenueTarget: 3000000,
            dealsCompleted: 101,
            avgPointsPerMember: 52050,
            campaignParticipation: 84,
            trainingCompletion: 65,
            pendingApprovals: 1,
            status: 'exceeding',
          },
          {
            id: 'team-45',
            name: 'International Epsilon',
            regionId: 'region-6',
            manager: 'Daniel Thompson',
            managerId: 'manager-45',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 1078000,
            monthlyTarget: 200000,
            totalRevenue: 15320000,
            revenueTarget: 3000000,
            dealsCompleted: 108,
            avgPointsPerMember: 51333,
            campaignParticipation: 87,
            trainingCompletion: 70,
            pendingApprovals: 3,
            status: 'exceeding',
          },
          {
            id: 'team-46',
            name: 'International Zeta',
            regionId: 'region-6',
            manager: 'Jessica Hill',
            managerId: 'manager-46',
            memberCount: 22,
            activeSalespeople: 22,
            totalPoints: 1065000,
            monthlyTarget: 200000,
            totalRevenue: 15850000,
            revenueTarget: 3000000,
            dealsCompleted: 115,
            avgPointsPerMember: 48409,
            campaignParticipation: 90,
            trainingCompletion: 75,
            pendingApprovals: 0,
            status: 'exceeding',
          },
          {
            id: 'team-47',
            name: 'International Eta',
            regionId: 'region-6',
            manager: 'Benjamin Cox',
            managerId: 'manager-47',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 1102000,
            monthlyTarget: 200000,
            totalRevenue: 15880000,
            revenueTarget: 3000000,
            dealsCompleted: 82,
            avgPointsPerMember: 55100,
            campaignParticipation: 93,
            trainingCompletion: 80,
            pendingApprovals: 2,
            status: 'exceeding',
          },
          {
            id: 'team-48',
            name: 'International Theta',
            regionId: 'region-6',
            manager: 'Alexander Morgan',
            managerId: 'manager-48',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 1139000,
            monthlyTarget: 200000,
            totalRevenue: 16410000,
            revenueTarget: 3000000,
            dealsCompleted: 89,
            avgPointsPerMember: 54238,
            campaignParticipation: 76,
            trainingCompletion: 85,
            pendingApprovals: 4,
            status: 'exceeding',
          },
        ],
        totalMembers: 167,
        totalPoints: 8426000,
        totalRevenue: 122440000,
        regionalTarget: 1600000,
        revenueTarget: 24000000,
        attainmentPercent: 527,
        revenueAttainment: 510,
        avgCampaignParticipation: 83,
        totalPendingApprovals: 16,
        teamsExceeding: 8,
        teamsNeedingAttention: 0,
      },
      {
        id: 'region-5',
        name: 'West',
        managerId: 'rm-5',
        teams: [
          {
            id: 'team-33',
            name: 'West Alpha',
            regionId: 'region-5',
            manager: 'Barbara Myers',
            managerId: 'manager-33',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 834000,
            monthlyTarget: 200000,
            totalRevenue: 11960000,
            revenueTarget: 3000000,
            dealsCompleted: 104,
            avgPointsPerMember: 41700,
            campaignParticipation: 91,
            trainingCompletion: 80,
            pendingApprovals: 4,
            status: 'exceeding',
          },
          {
            id: 'team-34',
            name: 'West Beta',
            regionId: 'region-5',
            manager: 'Olivia Garcia',
            managerId: 'manager-34',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 821000,
            monthlyTarget: 200000,
            totalRevenue: 11990000,
            revenueTarget: 3000000,
            dealsCompleted: 111,
            avgPointsPerMember: 39095,
            campaignParticipation: 94,
            trainingCompletion: 85,
            pendingApprovals: 1,
            status: 'exceeding',
          },
          {
            id: 'team-35',
            name: 'West Gamma',
            regionId: 'region-5',
            manager: 'Christina Ward',
            managerId: 'manager-35',
            memberCount: 22,
            activeSalespeople: 22,
            totalPoints: 858000,
            monthlyTarget: 200000,
            totalRevenue: 12520000,
            revenueTarget: 3000000,
            dealsCompleted: 118,
            avgPointsPerMember: 39000,
            campaignParticipation: 77,
            trainingCompletion: 90,
            pendingApprovals: 3,
            status: 'exceeding',
          },
          {
            id: 'team-36',
            name: 'West Delta',
            regionId: 'region-5',
            manager: 'Jerry Carter',
            managerId: 'manager-36',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 895000,
            monthlyTarget: 200000,
            totalRevenue: 12550000,
            revenueTarget: 3000000,
            dealsCompleted: 85,
            avgPointsPerMember: 44750,
            campaignParticipation: 80,
            trainingCompletion: 60,
            pendingApprovals: 0,
            status: 'exceeding',
          },
          {
            id: 'team-37',
            name: 'West Epsilon',
            regionId: 'region-5',
            manager: 'Heather Collins',
            managerId: 'manager-37',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 882000,
            monthlyTarget: 200000,
            totalRevenue: 13080000,
            revenueTarget: 3000000,
            dealsCompleted: 92,
            avgPointsPerMember: 42000,
            campaignParticipation: 83,
            trainingCompletion: 65,
            pendingApprovals: 2,
            status: 'exceeding',
          },
          {
            id: 'team-38',
            name: 'West Zeta',
            regionId: 'region-5',
            manager: 'Brenda Clark',
            managerId: 'manager-38',
            memberCount: 22,
            activeSalespeople: 22,
            totalPoints: 919000,
            monthlyTarget: 200000,
            totalRevenue: 13110000,
            revenueTarget: 3000000,
            dealsCompleted: 99,
            avgPointsPerMember: 41772,
            campaignParticipation: 86,
            trainingCompletion: 70,
            pendingApprovals: 4,
            status: 'exceeding',
          },
          {
            id: 'team-39',
            name: 'West Eta',
            regionId: 'region-5',
            manager: 'Helen Robinson',
            managerId: 'manager-39',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 956000,
            monthlyTarget: 200000,
            totalRevenue: 13640000,
            revenueTarget: 3000000,
            dealsCompleted: 106,
            avgPointsPerMember: 47800,
            campaignParticipation: 89,
            trainingCompletion: 75,
            pendingApprovals: 1,
            status: 'exceeding',
          },
          {
            id: 'team-40',
            name: 'West Theta',
            regionId: 'region-5',
            manager: 'Laura Kim',
            managerId: 'manager-40',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 943000,
            monthlyTarget: 200000,
            totalRevenue: 14170000,
            revenueTarget: 3000000,
            dealsCompleted: 113,
            avgPointsPerMember: 44904,
            campaignParticipation: 92,
            trainingCompletion: 80,
            pendingApprovals: 3,
            status: 'exceeding',
          },
        ],
        totalMembers: 167,
        totalPoints: 7108000,
        totalRevenue: 103020000,
        regionalTarget: 1600000,
        revenueTarget: 24000000,
        attainmentPercent: 444,
        revenueAttainment: 429,
        avgCampaignParticipation: 87,
        totalPendingApprovals: 18,
        teamsExceeding: 8,
        teamsNeedingAttention: 0,
      },
      {
        id: 'region-4',
        name: 'Southwest',
        managerId: 'rm-4',
        teams: [
          {
            id: 'team-25',
            name: 'Southwest Alpha',
            regionId: 'region-4',
            manager: 'Jacob Williams',
            managerId: 'manager-25',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 638000,
            monthlyTarget: 200000,
            totalRevenue: 9220000,
            revenueTarget: 3000000,
            dealsCompleted: 88,
            avgPointsPerMember: 31900,
            campaignParticipation: 87,
            trainingCompletion: 75,
            pendingApprovals: 3,
            status: 'exceeding',
          },
          {
            id: 'team-26',
            name: 'Southwest Beta',
            regionId: 'region-4',
            manager: 'Aaron Perry',
            managerId: 'manager-26',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 675000,
            monthlyTarget: 200000,
            totalRevenue: 9750000,
            revenueTarget: 3000000,
            dealsCompleted: 95,
            avgPointsPerMember: 32142,
            campaignParticipation: 90,
            trainingCompletion: 80,
            pendingApprovals: 0,
            status: 'exceeding',
          },
          {
            id: 'team-27',
            name: 'Southwest Gamma',
            regionId: 'region-4',
            manager: 'Amanda Harris',
            managerId: 'manager-27',
            memberCount: 22,
            activeSalespeople: 22,
            totalPoints: 712000,
            monthlyTarget: 200000,
            totalRevenue: 10280000,
            revenueTarget: 3000000,
            dealsCompleted: 102,
            avgPointsPerMember: 32363,
            campaignParticipation: 93,
            trainingCompletion: 85,
            pendingApprovals: 2,
            status: 'exceeding',
          },
          {
            id: 'team-28',
            name: 'Southwest Delta',
            regionId: 'region-4',
            manager: 'Sharon Myers',
            managerId: 'manager-28',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 699000,
            monthlyTarget: 200000,
            totalRevenue: 10310000,
            revenueTarget: 3000000,
            dealsCompleted: 109,
            avgPointsPerMember: 34950,
            campaignParticipation: 76,
            trainingCompletion: 90,
            pendingApprovals: 4,
            status: 'exceeding',
          },
          {
            id: 'team-29',
            name: 'Southwest Epsilon',
            regionId: 'region-4',
            manager: 'James Lopez',
            managerId: 'manager-29',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 736000,
            monthlyTarget: 200000,
            totalRevenue: 10840000,
            revenueTarget: 3000000,
            dealsCompleted: 116,
            avgPointsPerMember: 35047,
            campaignParticipation: 79,
            trainingCompletion: 60,
            pendingApprovals: 1,
            status: 'exceeding',
          },
          {
            id: 'team-30',
            name: 'Southwest Zeta',
            regionId: 'region-4',
            manager: 'Brandon Martinez',
            managerId: 'manager-30',
            memberCount: 22,
            activeSalespeople: 22,
            totalPoints: 773000,
            monthlyTarget: 200000,
            totalRevenue: 10870000,
            revenueTarget: 3000000,
            dealsCompleted: 83,
            avgPointsPerMember: 35136,
            campaignParticipation: 82,
            trainingCompletion: 65,
            pendingApprovals: 3,
            status: 'exceeding',
          },
          {
            id: 'team-31',
            name: 'Southwest Eta',
            regionId: 'region-4',
            manager: 'Robert Baker',
            managerId: 'manager-31',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 760000,
            monthlyTarget: 200000,
            totalRevenue: 11400000,
            revenueTarget: 3000000,
            dealsCompleted: 90,
            avgPointsPerMember: 38000,
            campaignParticipation: 85,
            trainingCompletion: 70,
            pendingApprovals: 0,
            status: 'exceeding',
          },
          {
            id: 'team-32',
            name: 'Southwest Theta',
            regionId: 'region-4',
            manager: 'William Baker',
            managerId: 'manager-32',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 797000,
            monthlyTarget: 200000,
            totalRevenue: 11430000,
            revenueTarget: 3000000,
            dealsCompleted: 97,
            avgPointsPerMember: 37952,
            campaignParticipation: 88,
            trainingCompletion: 75,
            pendingApprovals: 2,
            status: 'exceeding',
          },
        ],
        totalMembers: 167,
        totalPoints: 5790000,
        totalRevenue: 84100000,
        regionalTarget: 1600000,
        revenueTarget: 24000000,
        attainmentPercent: 362,
        revenueAttainment: 350,
        avgCampaignParticipation: 85,
        totalPendingApprovals: 15,
        teamsExceeding: 8,
        teamsNeedingAttention: 0,
      },
      {
        id: 'region-3',
        name: 'Central',
        managerId: 'rm-3',
        teams: [
          {
            id: 'team-17',
            name: 'Central Alpha',
            regionId: 'region-3',
            manager: 'Richard Adams',
            managerId: 'manager-17',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 492000,
            monthlyTarget: 200000,
            totalRevenue: 6980000,
            revenueTarget: 3000000,
            dealsCompleted: 112,
            avgPointsPerMember: 24600,
            campaignParticipation: 83,
            trainingCompletion: 70,
            pendingApprovals: 2,
            status: 'exceeding',
          },
          {
            id: 'team-18',
            name: 'Central Beta',
            regionId: 'region-3',
            manager: 'Christina Ortiz',
            managerId: 'manager-18',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 529000,
            monthlyTarget: 200000,
            totalRevenue: 7510000,
            revenueTarget: 3000000,
            dealsCompleted: 119,
            avgPointsPerMember: 25190,
            campaignParticipation: 86,
            trainingCompletion: 75,
            pendingApprovals: 4,
            status: 'exceeding',
          },
          {
            id: 'team-19',
            name: 'Central Gamma',
            regionId: 'region-3',
            manager: 'Christopher Alvarez',
            managerId: 'manager-19',
            memberCount: 22,
            activeSalespeople: 22,
            totalPoints: 516000,
            monthlyTarget: 200000,
            totalRevenue: 7540000,
            revenueTarget: 3000000,
            dealsCompleted: 86,
            avgPointsPerMember: 23454,
            campaignParticipation: 89,
            trainingCompletion: 80,
            pendingApprovals: 1,
            status: 'exceeding',
          },
          {
            id: 'team-20',
            name: 'Central Delta',
            regionId: 'region-3',
            manager: 'Kathleen Evans',
            managerId: 'manager-20',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 553000,
            monthlyTarget: 200000,
            totalRevenue: 8070000,
            revenueTarget: 3000000,
            dealsCompleted: 93,
            avgPointsPerMember: 27650,
            campaignParticipation: 92,
            trainingCompletion: 85,
            pendingApprovals: 3,
            status: 'exceeding',
          },
          {
            id: 'team-21',
            name: 'Central Epsilon',
            regionId: 'region-3',
            manager: 'Laura Ward',
            managerId: 'manager-21',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 590000,
            monthlyTarget: 200000,
            totalRevenue: 8100000,
            revenueTarget: 3000000,
            dealsCompleted: 100,
            avgPointsPerMember: 28095,
            campaignParticipation: 75,
            trainingCompletion: 90,
            pendingApprovals: 0,
            status: 'exceeding',
          },
          {
            id: 'team-22',
            name: 'Central Zeta',
            regionId: 'region-3',
            manager: 'Gary Anderson',
            managerId: 'manager-22',
            memberCount: 22,
            activeSalespeople: 22,
            totalPoints: 577000,
            monthlyTarget: 200000,
            totalRevenue: 8630000,
            revenueTarget: 3000000,
            dealsCompleted: 107,
            avgPointsPerMember: 26227,
            campaignParticipation: 78,
            trainingCompletion: 60,
            pendingApprovals: 2,
            status: 'exceeding',
          },
          {
            id: 'team-23',
            name: 'Central Eta',
            regionId: 'region-3',
            manager: 'Carol Roberts',
            managerId: 'manager-23',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 614000,
            monthlyTarget: 200000,
            totalRevenue: 8660000,
            revenueTarget: 3000000,
            dealsCompleted: 114,
            avgPointsPerMember: 30700,
            campaignParticipation: 81,
            trainingCompletion: 65,
            pendingApprovals: 4,
            status: 'exceeding',
          },
          {
            id: 'team-24',
            name: 'Central Theta',
            regionId: 'region-3',
            manager: 'Shirley Rodriguez',
            managerId: 'manager-24',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 651000,
            monthlyTarget: 200000,
            totalRevenue: 9190000,
            revenueTarget: 3000000,
            dealsCompleted: 81,
            avgPointsPerMember: 31000,
            campaignParticipation: 84,
            trainingCompletion: 70,
            pendingApprovals: 1,
            status: 'exceeding',
          },
        ],
        totalMembers: 167,
        totalPoints: 4522000,
        totalRevenue: 64680000,
        regionalTarget: 1600000,
        revenueTarget: 24000000,
        attainmentPercent: 283,
        revenueAttainment: 270,
        avgCampaignParticipation: 84,
        totalPendingApprovals: 17,
        teamsExceeding: 8,
        teamsNeedingAttention: 0,
      },
      {
        id: 'region-2',
        name: 'Southeast',
        managerId: 'rm-2',
        teams: [
          {
            id: 'team-9',
            name: 'Southeast Alpha',
            regionId: 'region-2',
            manager: 'Daniel White',
            managerId: 'manager-9',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 346000,
            monthlyTarget: 200000,
            totalRevenue: 4740000,
            revenueTarget: 3000000,
            dealsCompleted: 96,
            avgPointsPerMember: 17300,
            campaignParticipation: 79,
            trainingCompletion: 65,
            pendingApprovals: 1,
            status: 'exceeding',
          },
          {
            id: 'team-10',
            name: 'Southeast Beta',
            regionId: 'region-2',
            manager: 'Jessica Richardson',
            managerId: 'manager-10',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 333000,
            monthlyTarget: 200000,
            totalRevenue: 4770000,
            revenueTarget: 3000000,
            dealsCompleted: 103,
            avgPointsPerMember: 15857,
            campaignParticipation: 82,
            trainingCompletion: 70,
            pendingApprovals: 3,
            status: 'exceeding',
          },
          {
            id: 'team-11',
            name: 'Southeast Gamma',
            regionId: 'region-2',
            manager: 'Karen Morgan',
            managerId: 'manager-11',
            memberCount: 22,
            activeSalespeople: 22,
            totalPoints: 370000,
            monthlyTarget: 200000,
            totalRevenue: 5300000,
            revenueTarget: 3000000,
            dealsCompleted: 110,
            avgPointsPerMember: 16818,
            campaignParticipation: 85,
            trainingCompletion: 75,
            pendingApprovals: 0,
            status: 'exceeding',
          },
          {
            id: 'team-12',
            name: 'Southeast Delta',
            regionId: 'region-2',
            manager: 'Patricia Nguyen',
            managerId: 'manager-12',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 407000,
            monthlyTarget: 200000,
            totalRevenue: 5330000,
            revenueTarget: 3000000,
            dealsCompleted: 117,
            avgPointsPerMember: 20350,
            campaignParticipation: 88,
            trainingCompletion: 80,
            pendingApprovals: 2,
            status: 'exceeding',
          },
          {
            id: 'team-13',
            name: 'Southeast Epsilon',
            regionId: 'region-2',
            manager: 'Eric Edwards',
            managerId: 'manager-13',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 394000,
            monthlyTarget: 200000,
            totalRevenue: 5860000,
            revenueTarget: 3000000,
            dealsCompleted: 84,
            avgPointsPerMember: 18761,
            campaignParticipation: 91,
            trainingCompletion: 85,
            pendingApprovals: 4,
            status: 'exceeding',
          },
          {
            id: 'team-14',
            name: 'Southeast Zeta',
            regionId: 'region-2',
            manager: 'Ruth Morris',
            managerId: 'manager-14',
            memberCount: 22,
            activeSalespeople: 22,
            totalPoints: 431000,
            monthlyTarget: 200000,
            totalRevenue: 6390000,
            revenueTarget: 3000000,
            dealsCompleted: 91,
            avgPointsPerMember: 19590,
            campaignParticipation: 94,
            trainingCompletion: 90,
            pendingApprovals: 1,
            status: 'exceeding',
          },
          {
            id: 'team-15',
            name: 'Southeast Eta',
            regionId: 'region-2',
            manager: 'Samuel Lewis',
            managerId: 'manager-15',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 468000,
            monthlyTarget: 200000,
            totalRevenue: 6420000,
            revenueTarget: 3000000,
            dealsCompleted: 98,
            avgPointsPerMember: 23400,
            campaignParticipation: 77,
            trainingCompletion: 60,
            pendingApprovals: 3,
            status: 'exceeding',
          },
          {
            id: 'team-16',
            name: 'Southeast Theta',
            regionId: 'region-2',
            manager: 'Carol Howard',
            managerId: 'manager-16',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 455000,
            monthlyTarget: 200000,
            totalRevenue: 6950000,
            revenueTarget: 3000000,
            dealsCompleted: 105,
            avgPointsPerMember: 21666,
            campaignParticipation: 80,
            trainingCompletion: 65,
            pendingApprovals: 0,
            status: 'exceeding',
          },
        ],
        totalMembers: 167,
        totalPoints: 3204000,
        totalRevenue: 45760000,
        regionalTarget: 1600000,
        revenueTarget: 24000000,
        attainmentPercent: 200,
        revenueAttainment: 191,
        avgCampaignParticipation: 85,
        totalPendingApprovals: 14,
        teamsExceeding: 8,
        teamsNeedingAttention: 0,
      },
      {
        id: 'region-1',
        name: 'Northeast',
        managerId: 'rm-1',
        teams: [
          {
            id: 'team-1',
            name: 'Northeast Alpha',
            regionId: 'region-1',
            manager: 'Marcus Hayes',
            managerId: 'manager-1',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 150000,
            monthlyTarget: 200000,
            totalRevenue: 2000000,
            revenueTarget: 3000000,
            dealsCompleted: 80,
            avgPointsPerMember: 7500,
            campaignParticipation: 75,
            trainingCompletion: 60,
            pendingApprovals: 0,
            status: 'needs_attention',
          },
          {
            id: 'team-2',
            name: 'Northeast Beta',
            regionId: 'region-1',
            manager: 'Virginia White',
            managerId: 'manager-2',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 187000,
            monthlyTarget: 200000,
            totalRevenue: 2530000,
            revenueTarget: 3000000,
            dealsCompleted: 87,
            avgPointsPerMember: 8904,
            campaignParticipation: 78,
            trainingCompletion: 65,
            pendingApprovals: 2,
            status: 'on_track',
          },
          {
            id: 'team-3',
            name: 'Northeast Gamma',
            regionId: 'region-1',
            manager: 'Dorothy Diaz',
            managerId: 'manager-3',
            memberCount: 22,
            activeSalespeople: 22,
            totalPoints: 224000,
            monthlyTarget: 200000,
            totalRevenue: 3060000,
            revenueTarget: 3000000,
            dealsCompleted: 94,
            avgPointsPerMember: 10181,
            campaignParticipation: 81,
            trainingCompletion: 70,
            pendingApprovals: 4,
            status: 'exceeding',
          },
          {
            id: 'team-4',
            name: 'Northeast Delta',
            regionId: 'region-1',
            manager: 'Raymond Morgan',
            managerId: 'manager-4',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 211000,
            monthlyTarget: 200000,
            totalRevenue: 3090000,
            revenueTarget: 3000000,
            dealsCompleted: 101,
            avgPointsPerMember: 10550,
            campaignParticipation: 84,
            trainingCompletion: 75,
            pendingApprovals: 1,
            status: 'exceeding',
          },
          {
            id: 'team-5',
            name: 'Northeast Epsilon',
            regionId: 'region-1',
            manager: 'Christopher Martin',
            managerId: 'manager-5',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 248000,
            monthlyTarget: 200000,
            totalRevenue: 3620000,
            revenueTarget: 3000000,
            dealsCompleted: 108,
            avgPointsPerMember: 11809,
            campaignParticipation: 87,
            trainingCompletion: 80,
            pendingApprovals: 3,
            status: 'exceeding',
          },
          {
            id: 'team-6',
            name: 'Northeast Zeta',
            regionId: 'region-1',
            manager: 'Patricia Russell',
            managerId: 'manager-6',
            memberCount: 22,
            activeSalespeople: 22,
            totalPoints: 285000,
            monthlyTarget: 200000,
            totalRevenue: 3650000,
            revenueTarget: 3000000,
            dealsCompleted: 115,
            avgPointsPerMember: 12954,
            campaignParticipation: 90,
            trainingCompletion: 85,
            pendingApprovals: 0,
            status: 'exceeding',
          },
          {
            id: 'team-7',
            name: 'Northeast Eta',
            regionId: 'region-1',
            manager: 'Deborah Wilson',
            managerId: 'manager-7',
            memberCount: 20,
            activeSalespeople: 20,
            totalPoints: 272000,
            monthlyTarget: 200000,
            totalRevenue: 4180000,
            revenueTarget: 3000000,
            dealsCompleted: 82,
            avgPointsPerMember: 13600,
            campaignParticipation: 93,
            trainingCompletion: 90,
            pendingApprovals: 2,
            status: 'exceeding',
          },
          {
            id: 'team-8',
            name: 'Northeast Theta',
            regionId: 'region-1',
            manager: 'George Morales',
            managerId: 'manager-8',
            memberCount: 21,
            activeSalespeople: 21,
            totalPoints: 309000,
            monthlyTarget: 200000,
            totalRevenue: 4210000,
            revenueTarget: 3000000,
            dealsCompleted: 89,
            avgPointsPerMember: 14714,
            campaignParticipation: 76,
            trainingCompletion: 60,
            pendingApprovals: 4,
            status: 'exceeding',
          },
        ],
        totalMembers: 167,
        totalPoints: 1886000,
        totalRevenue: 26340000,
        regionalTarget: 1600000,
        revenueTarget: 24000000,
        attainmentPercent: 118,
        revenueAttainment: 110,
        avgCampaignParticipation: 83,
        totalPendingApprovals: 16,
        teamsExceeding: 6,
        teamsNeedingAttention: 1,
      },
    ],
    pending_manual_adjustments: [
      {
        id: '1',
        user: 'Olivia Murphy',
        requestedBy: 'Marcus Hayes (Manager)',
        points: 5000,
        reason: 'Exceptional Sentri-7 product knowledge certification',
        status: 'pending',
        date: '2026-02-05',
      },
      {
        id: '2',
        user: 'Michael Chen',
        requestedBy: 'Marcus Hayes (Manager)',
        points: -2000,
        reason: 'Points correction - duplicate entry',
        status: 'pending',
        date: '2026-02-04',
      },
      {
        id: '3',
        user: 'Emma Williams',
        requestedBy: 'Marcus Hayes (Manager)',
        points: 3000,
        reason: 'Team leadership during Sentri-7 launch',
        status: 'pending',
        date: '2026-02-03',
      },
      {
        id: '4',
        user: 'James Wilson',
        requestedBy: 'System',
        points: 1500,
        reason: 'Bonus points for mentoring new team members',
        status: 'pending',
        date: '2026-02-02',
      },
      {
        id: '5',
        user: 'Olivia Murphy',
        requestedBy: 'Marcus Hayes (Manager)',
        points: 2500,
        reason: 'Peer mentor reward for Sentri-7 launch',
        status: 'pending',
        date: '2026-02-01',
      },
    ],
  },
  regional_manager: {
    overview: [
      {
        title: 'Total Team Members',
        value: 167,
        subtitle: `8 teams`,
      },
      {
        title: 'Total Points Earned (This Month)',
        value: '1886K',
        subtitle: '+7% vs last month',
      },
      {
        title: 'Total Revenue (This Month)',
        value: '$26.3M',
        subtitle: '+5% vs last month',
      },
      {
        title: 'Campaign Participation',
        value: '83%',
        subtitle: 'avg across teams',
      },
      {
        title: 'Pending Escalations',
        value: 0,
        subtitle: 'require your approval',
      },
    ],
    'comparison-charts': [
      {
        type: 'bar',
        title: 'Points Attainment by Team',
        dataKey: 'team',
        data: [
          {
            team: 'Theta',
            points: 309,
            target: 200,
            attainment: 155,
          },
          {
            team: 'Zeta',
            points: 285,
            target: 200,
            attainment: 143,
          },
          {
            team: 'Eta',
            points: 272,
            target: 200,
            attainment: 136,
          },
          {
            team: 'Epsilon',
            points: 248,
            target: 200,
            attainment: 124,
          },
          {
            team: 'Gamma',
            points: 224,
            target: 200,
            attainment: 112,
          },
          {
            team: 'Delta',
            points: 211,
            target: 200,
            attainment: 106,
          },
          {
            team: 'Beta',
            points: 187,
            target: 200,
            attainment: 94,
          },
          {
            team: 'Alpha',
            points: 150,
            target: 200,
            attainment: 75,
          },
        ],
      },
    ],
    leaderboard: [
      {
        id: 'northeast-theta',
        name: 'Northeast Theta',
        dealerName: 'George Morales',
        active: '21/21',
        totalPoints: 309000,
        totalRevenue: 4200000,
        attainmentPercent: 93,
      },
      {
        id: 'northeast-zeta',
        name: 'Northeast Zeta',
        dealerName: 'Patricia Russell',
        active: '22/22',
        totalPoints: 109000,
        totalRevenue: 200000,
        attainmentPercent: 57,
      },
      {
        id: 'northeast-eta',
        name: 'Northeast Eta',
        dealerName: 'Deborah Wilson',
        active: '20/20',
        totalPoints: 509000,
        totalRevenue: 5200000,
        attainmentPercent: 85,
      },
      {
        id: 'northeast-epsilon',
        name: 'Northeast Epsilon',
        dealerName: 'Christopher Martin',
        active: '21/21',
        totalPoints: 809000,
        totalRevenue: 7200000,
        attainmentPercent: 45,
      },
    ],
  },

  program_manager: {
    overview: [
      {
        title: 'Distributors',
        value: 9,
      },
      {
        title: 'Partner Companies',
        value: 12,
        subtitle: '30 Stores',
      },
      {
        title: 'Program Revenue',
        value: '$1.9M',
        subtitle: 'This month',
      },
      {
        title: 'Total Points Earned',
        value: '865K',
        subtitle: 'Avg 72,143 per company',
      },
      {
        title: 'Units Sold',
        value: 808,
        subtitle: 'This month',
      },
    ],
    'comparison-table': [
      {
        id: 'cam-1',
        name: 'Catherine Morales',
        role: 'channel_account_manager',
        initials: 'CM',
        programType: 'channel',
        managedTerritoryIds: ['territory-1', 'territory-2', 'territory-3'],
        count: '304,482 pts',
        perf: {
          distributorId: 'cam-1',
          distributorName: 'Catherine Morales',
          accountCount: 3,
          monthlyRevenue: 690498,
          maxRevenue: 6904982,
          totalPoints: 304482,
          totalUnits: 261,
          revenueChange: 6,
          tier: 'Gold',
        },
      },
      {
        id: 'cam-2',
        name: 'Kathleen Baker',
        role: 'channel_account_manager',
        initials: 'KB',
        programType: 'channel',
        managedTerritoryIds: ['territory-4', 'territory-5', 'territory-1'],
        count: '104,482 pts',
        perf: {
          distributorId: 'cam-2',
          distributorName: 'Kathleen Baker',
          accountCount: 3,
          monthlyRevenue: 433772,
          maxRevenue: 6904982,
          totalPoints: 226567,
          totalUnits: 225,
          revenueChange: 6,
          tier: 'Silver',
        },
      },
      {
        id: 'cam-3',
        name: 'Samuel Smith',
        role: 'channel_account_manager',
        initials: 'SS',
        programType: 'channel',
        managedTerritoryIds: ['territory-2', 'territory-3', 'territory-4'],
        count: '204,482 pts',
        perf: {
          distributorId: 'cam-3',
          distributorName: 'Samuel Smith',
          accountCount: 3,
          monthlyRevenue: 361341,
          maxRevenue: 6904982,
          totalPoints: 180357,
          totalUnits: 117,
          revenueChange: 4,
          tier: 'Silver',
        },
      },
      {
        id: 'cam-4',
        name: 'Jerry Roberts',
        role: 'channel_account_manager',
        initials: 'JR',
        programType: 'channel',
        managedTerritoryIds: ['territory-5', 'territory-1', 'territory-2'],
        count: '504,482 pts',
        perf: {
          distributorId: 'cam-4',
          distributorName: 'Jerry Roberts',
          accountCount: 3,
          monthlyRevenue: 431278,
          maxRevenue: 4904982,
          totalPoints: 154310,
          totalUnits: 205,
          revenueChange: 11,
          tier: 'Bronze',
        },
      },
    ],
    rankings: [
      {
        dealerId: 'dealer-3',
        dealerName: 'Northern Drive Group',
        points: 109085,
        tier: 'Gold',
        revenue: 247547,
      },
      {
        dealerId: 'dealer-1',
        dealerName: 'Apex Auto Group',
        points: 106740,
        tier: 'Gold',
        revenue: 201814,
      },
      {
        dealerId: 'dealer-6',
        dealerName: 'Heartland Auto Supply',
        points: 93214,
        tier: 'Gold',
        revenue: 173855,
      },
      {
        dealerId: 'dealer-4',
        dealerName: 'Velocity Service Network',
        points: 88845,
        tier: 'Gold',
        revenue: 188850,
      },
      {
        dealerId: 'dealer-2',
        dealerName: 'Summit Parts Network',
        points: 88657,
        tier: 'Gold',
        revenue: 241137,
      },
      {
        dealerId: 'dealer-11',
        dealerName: 'Mountain View Service',
        points: 67079,
        tier: 'Gold',
        revenue: 134206,
      },
      {
        dealerId: 'dealer-8',
        dealerName: 'Pinnacle Parts Plus',
        points: 64793,
        tier: 'Gold',
        revenue: 146514,
      },
      {
        dealerId: 'dealer-7',
        dealerName: 'Atlantic Service Centers',
        points: 59264,
        tier: 'Gold',
        revenue: 96969,
      },
      {
        dealerId: 'dealer-9',
        dealerName: 'Frontier Brake Specialists',
        points: 56300,
        tier: 'Gold',
        revenue: 117858,
      },
      {
        dealerId: 'dealer-10',
        dealerName: 'Coastal Auto Partners',
        points: 49947,
        tier: 'Silver',
        revenue: 150137,
      },
      {
        dealerId: 'dealer-5',
        dealerName: 'Pacific Brake Partners',
        points: 44508,
        tier: 'Silver',
        revenue: 71067,
      },
      {
        dealerId: 'dealer-12',
        dealerName: 'Great Lakes Parts Supply',
        points: 37284,
        tier: 'Silver',
        revenue: 146935,
      },
    ],
    engagement: {
      activeParticipants: 102,
      totalMembers: 1200,
      tierDistribution: [
        {
          tier: 'Bronze',
          members: 301,
          points: 5576025,
          avgPoints: 18525,
        },
        {
          tier: 'Silver',
          members: 351,
          points: 8669349,
          avgPoints: 24699,
        },
        {
          tier: 'Gold',
          members: 251,
          points: 9299299,
          avgPoints: 37049,
        },
        {
          tier: 'Platinum',
          members: 100,
          points: 6174900,
          avgPoints: 61749,
        },
      ],
      topRewards: [
        {
          id: '1',
          name: 'Wireless Headphones',
          category: 'Electronics',
          timesRedeemed: 411,
          totalPoints: 2054100,
        },
        {
          id: '4',
          name: 'Spa Treatment',
          category: 'Experiences',
          timesRedeemed: 80,
          totalPoints: 1603200,
        },
        {
          id: '2',
          name: 'Smartwatch',
          category: 'Electronics',
          timesRedeemed: 251,
          totalPoints: 1565625,
        },
        {
          id: '3',
          name: 'Luxury Watch',
          category: 'Merchandise',
          timesRedeemed: 120,
          totalPoints: 1052100,
        },
        {
          id: '5',
          name: 'Designer Handbag',
          category: 'Merchandise',
          timesRedeemed: 150,
          totalPoints: 826650,
        },
      ],
    },
  },
  account_manager: {
    overview: [
      {
        title: 'Partner Companies',
        value: 3,
        subtitle: `9 stores`,
      },
      {
        title: 'Total Revenue',
        value: '$690K',
        subtitle: 'This month',
      },
      {
        title: 'Total Points Earned',
        value: '$304K',
        subtitle: 'Accross all partners',
      },
      {
        title: 'Units Sold',
        value: 261,
        subtitle: 'This month',
      },
    ],
    rankings: [
      {
        dealerId: 'dealer-3',
        dealerName: 'Northern Drive Group',
        points: 109085,
        tier: 'Gold',
        revenue: 247547,
      },
      {
        dealerId: 'dealer-1',
        dealerName: 'Apex Auto Group',
        points: 106740,
        tier: 'Silver',
        revenue: 201814,
      },
      {
        dealerId: 'dealer-6',
        dealerName: 'Summits Parts Network',
        points: 93214,
        tier: 'Gold',
        revenue: 173855,
      },
    ],
    'comparison-table': [
      {
        id: 'cam-1',
        name: 'Northern Drive Group',
        role: 'channel_account_manager',
        initials: 'CM',
        programType: 'channel',
        managedTerritoryIds: ['territory-1', 'territory-2', 'territory-3'],
        count: '304,482 pts',
        perf: {
          distributorId: 'cam-1',
          distributorName: 'Catherine Morales',
          accountCount: 3,
          monthlyRevenue: 690498,
          maxRevenue: 6904982,
          totalPoints: 304482,
          totalUnits: 261,
          revenueChange: 6,
          tier: 'Gold',
        },
      },
      {
        id: 'cam-2',
        name: 'Summit Parts Network',
        role: 'channel_account_manager',
        initials: 'KB',
        programType: 'channel',
        managedTerritoryIds: ['territory-4', 'territory-5', 'territory-1'],
        count: '104,482 pts',
        perf: {
          distributorId: 'cam-2',
          distributorName: 'Kathleen Baker',
          accountCount: 3,
          monthlyRevenue: 433772,
          maxRevenue: 6904982,
          totalPoints: 226567,
          totalUnits: 225,
          revenueChange: 6,
          tier: 'Silver',
        },
      },
      {
        id: 'cam-3',
        name: 'Apex Auto Group',
        role: 'channel_account_manager',
        initials: 'SS',
        programType: 'channel',
        managedTerritoryIds: ['territory-2', 'territory-3', 'territory-4'],
        count: '204,482 pts',
        perf: {
          distributorId: 'cam-3',
          distributorName: 'Samuel Smith',
          accountCount: 3,
          monthlyRevenue: 361341,
          maxRevenue: 6904982,
          totalPoints: 180357,
          totalUnits: 117,
          revenueChange: 4,
          tier: 'Silver',
        },
      },
    ],
    'needs-attention': [],
  },
  dealer_staff: {
    tier_progress: {
      current: 36367,
      target: 50000,
      currentTier: 'Silver',
      nextTier: 'Gold',
    },
    performance: [
      {
        title: 'Store Points Earned',
        value: 36367,
        subtitle: 'Total earned by this store',
      },
      {
        title: 'Points This month',
        value: 4781,
        subtitle: 'Monthly store earnings',
      },
      {
        title: 'Monthly revenue',
        value: '$21K',
        subtitle: '+6% vs last month',
      },
      {
        title: 'Campaign Participation',
        value: '67%',
      },
    ],
    rankings: [
      {
        dealerId: 'dealer-3',
        dealerName: 'Toronto East Store',
        points: 109085,
        tier: 'Gold',
        revenue: 247547,
      },
      {
        dealerId: 'dealer-1',
        dealerName: 'Denver Parts Store',
        points: 106740,
        tier: 'Silver',
        revenue: 201814,
      },
      {
        dealerId: 'dealer-6',
        dealerName: 'Burnaby Parts Location',
        points: 93214,
        tier: 'Gold',
        revenue: 173855,
      },
      {
        dealerId: 'dealer-6',
        dealerName: 'Calgary North Store',
        points: 93214,
        tier: 'Gold',
        revenue: 173855,
        isCurrentUser: true,
      },
    ],
    'earning-history': [
      {
        id: '1',
        date: format(new Date(), 'yyyy-MM-dd'),
        activity: 'Sentri-7 Certification Completion',
        points: 1500,
      },
      {
        id: '2',
        date: format(
          new Date(Date.now() - 2 * 24 * 60 * 60 * 1000),
          'yyyy-MM-dd',
        ),
        activity: 'CRM Sync: Sentri-7 Contract - Acme Health',
        points: 3750,
      },
      {
        id: '3',
        date: format(
          new Date(Date.now() - 5 * 24 * 60 * 60 * 1000),
          'yyyy-MM-dd',
        ),
        activity: 'Recognition Award from Marcus Hayes',
        points: 1000,
      },
      {
        id: '4',
        date: format(
          new Date(Date.now() - 10 * 24 * 60 * 60 * 1000),
          'yyyy-MM-dd',
        ),
        activity: 'Sentri-7 Early Adopter Bonus',
        points: 2500,
      },
      {
        id: '5',
        date: '2026-01-20',
        activity: 'Monthly Sales Target Achieved',
        points: 3000,
      },
      {
        id: '6',
        date: '2026-01-15',
        activity: 'New Customer Acquisition Bonus',
        points: 1500,
      },
      {
        id: '7',
        date: '2026-01-10',
        activity: 'Product Training Completion',
        points: 500,
      },
      {
        id: '8',
        date: '2026-01-05',
        activity: 'Weekly Sales Target',
        points: 800,
      },
    ],
  },
}
